<template>
  
    <v-app>
        
        <v-main>
    
            <!-- Barra preta -->
            <v-toolbar
                color="black"
                dense
                flat
                :style="{
                    'border-top-left-radius': '12px',
                    'border-top-right-radius': '8px',
                    'position': 'fixed',
                    'top': '64px',
                    'left': modoBarraLateral ? '70px' : '260px',
                    'width': modoBarraLateral ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
                    'z-index': '999',
                    'transition': 'left 0.3s ease, width 0.3s ease'
                }"
            >        
                <!-- Barra de seleção/apresentação dos status e quantidade de chamados para cada tipo -->
                <v-select
                    v-model="statusSelecionados"
                    :items="opcoesStatus"
                    item-title="title"
                    item-value="value"
                    multiple
                    chips
                    closable-chips
                    :clearable="true"
                    bg-color="black"
                    style="margin-top: 25px; width: 100%;"
                    @update:modelValue="carregaListaChamados"
                >
                    <!-- Slot chip no Vuetify 3 -->
                    <template v-slot:chip="{ item }">

                        <v-chip
                            :color="getChipColor(item.value)"
                            class="ma-1"
                            closable
                            @click:close="removerStatus(item.value)"
                        >
                            {{ buscaTitulo(item.value) }}
                            <span class="ml-1 count-badge">
                                {{ buscaContagem(item.value) }}
                            </span>
                        </v-chip>

                    </template>
                    
                </v-select>
                
                <!-- Botão de novo chamado -->
                <v-spacer />   
                <v-col cols="auto">

                    <v-tooltip text="Novo Chamado" location="top">

                        <template #activator="{ props }">

                            <v-btn
                                v-bind="props"
                                icon
                                large
                                class="rounded-button"
                                href="#"
                                tag="a"
                                style="background-color: #4CAF50;"
                                @click="novoChamado"
                            >
                                <v-icon color="white">mdi-plus</v-icon>
                            </v-btn> 

                        </template>               

                    </v-tooltip>

                </v-col>
                
            </v-toolbar>
            
            <v-container fluid class="pa-4">

                <v-card class="pa-4" style="width: 100%;">
                    
                    <!-- Campo de busca -->
                    <v-text-field
                        v-model="textoBusca"
                        label="Pesquisar"
                        placeholder="Digite sua busca..."
                        prepend-inner-icon="mdi-magnify"
                        variant="outlined"
                        :clearable="true"
                        @keyup.enter="carregaListaChamados"
                        @click:clear="limpaDadosPesquisa"
                        @update:modelValue="atualizaParamentrosBusca"
                        style="margin-top: 60px;" 
                    >
                    
                        <template v-slot:append-inner>
                            <v-icon 
                                @click="carregaListaChamados"
                                title="Recarregar lista"
                                style="cursor: pointer;"
                            >
                                mdi-reload
                            </v-icon>
                        </template>
                    </v-text-field>

                    <!-- Tabela de chamados -->
                    <v-data-table-server
                        item-value="idChamado"
                        v-model:options="opcoesTabelaChamados"
                        :headers="headersChamados"
                        :items="listaChamados"
                        :loading="carregandoChamados"
                        :items-length="totalChamados"
                        @update:options="carregaListaChamados"
                        class="elevation-2 rounded-lg"
                        density="compact"
                        :style="{ 
                            'font-family': 'Arial, sans-serif !important', 
                            'font-size': '11px !important' 
                        }"
                        hide-default-footer
                    >
                        <!-- Slot para renderizar cada linha -->
                        <template #item="{ item }">

                            <tr
                                @click="selecionarLinha(item.idChamado)"
                                :class="{ 'linha-chamado-selecionada': linhaSelecionada.includes(item.idChamado) }"
                                style="cursor: pointer;"
                            >
                                <!-- Ações agrupadas em menu -->
                                <td>
                                    <v-menu v-model="item.escondeMenu">

                                        <!-- Renderiza os botões de função da lista de chamados -->
                                        <template #activator="{ props }">
                                            <v-btn icon v-bind="props" size="small">
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>

                                        <!-- Lista de funções dos atalhos -->
                                        <v-list>
                                            
                                            <v-list-item @click.stop="editaChamado(item, 0)">
                                                <v-icon start color="orange-darken-2">mdi-pencil</v-icon>
                                                Editar Chamado
                                            </v-list-item>
                                            
                                            <v-list-item @click.stop="editaChamado(item, 1)">                                            
                                                <v-icon start color="primary">mdi-walk</v-icon>
                                                Executar Chamado
                                            </v-list-item>
                                            
                                            <v-list-item @click.stop="editaChamado(item, 2)">                                            
                                                <v-icon start color="red-lighten-1">mdi-clock-time-five-outline</v-icon>
                                                Chamado Pendente
                                            </v-list-item>

                                            <v-list-item @click.stop="editaChamado(item, 3)">                                            
                                                <v-icon start color="red-darken-2">mdi-account-clock-outline</v-icon>
                                                Chamado Pendente Cliente
                                            </v-list-item>
                                            
                                            <v-list-item @click.stop="editaChamado(item, 4)">                                            
                                                <v-icon start color="yellow">mdi-cash-multiple</v-icon>
                                                Orçamento
                                            </v-list-item>
                                            
                                            <v-list-item @click.stop="editaChamado(item, 5)">                                            
                                                <v-icon start color="green">mdi-cash-multiple</v-icon>
                                                Liberar Orçamento
                                            </v-list-item>

                                            <v-list-item @click.stop="editaChamado(item, 8)">
                                                <v-icon start color="blue">mdi-forum</v-icon>
                                                Chat do Chamado
                                            </v-list-item>
                                            
                                            <!-- Separador -->
                                            <v-divider class="my-1" />
                                            
                                            <!-- Trata menu Novo Comentário -->
                                            <v-list-item @click.stop="criarEditarComentario(item, item.id, 'listaChamados')"> 
                                                <v-icon start>mdi-account-arrow-up</v-icon>
                                                Novo Comentário
                                            </v-list-item>

                                            <v-list-item @click.stop="listaComentariosChamado(item, false)">                                            
                                                <v-icon start :class="{ blinkIcone: item.existeComentario !== 0 }">mdi-eye</v-icon>
                                                Listar Comentários
                                            </v-list-item>
                                            
                                            <v-list-item @click.stop="listaRegistrosChamado(item, false)">                                            
                                                <v-icon>mdi-clipboard-text-outline</v-icon>
                                                Listar Registros Chamado
                                            </v-list-item>

                                            <!-- Separador -->
                                            <v-divider class="my-1" />

                                            <v-list-item @click.stop="pedeConfirmacaoExclusao(item)">                                            
                                                <v-icon icon="mdi-delete" color="red" />
                                                Excluir Chamado
                                            </v-list-item>
                                            
                                        </v-list>

                                    </v-menu>
                                    
                                </td>

                                <!-- Dados principais -->
                                <td>
                                    <a href="#" @click.prevent="editaChamado(item, 0)">
                                        {{ item.idChamado }}
                                    </a>
                                </td>

                                <!-- Substitua o tooltip existente por este -->
                                <td>
                                    
                                    <v-tooltip
                                        v-model="showTooltip[item.idChamado]"
                                        :text="tooltipText[item.idChamado] || 'Carregando...'"
                                        location="top"
                                        :open-delay="500"
                                        max-width="300"
                                        >
                                        <template #activator="{ props }">

                                            <v-chip 
                                                v-bind="props"
                                                :color="statusColor(item.Status)" 
                                                size="small"
                                                :class="{ 'blink-color-status': item.existeComentario !== 0 }"
                                                @dblclick="editaChamado(item, 0)"
                                                @mouseenter="carregarTextoDoChamado(item)"
                                                @mouseleave="fecharTooltip(item.idChamado)"
                                                style="font-size: 10px;"
                                                >
                                                {{ item.Status }}
                                            </v-chip>

                                        </template>

                                    </v-tooltip>

                                </td>

                                <td>{{ item.Cliente }}</td>
                                <td>{{ item.Solicitante }}</td>
                                <td>{{ item.Prioridade }}</td>
                                <td>{{ item.Abertura }}</td>
                                <td>{{ item.Recursos }}</td>
                                <td>{{ item.Concluído }}</td>
                                <td>{{ item.Tag }}</td>
                            </tr>

                            <!-- Linha expandida com comentários -->
                            <transition name="expand">

                                <tr v-if="linhaComentarios(item.idChamado)">
                                    
                                    <td colspan="12" class="pa-0" style="background-color: #f5f5f5;">

                                        <div style="padding-left: 30px;">

                                            <div style="position: relative;">
                                                <v-btn
                                                    icon
                                                    color="blue"
                                                    size="x-small"
                                                    style="position: absolute; top: -2px; right: 8px; z-index: 10;"
                                                    @click.stop="listaComentariosChamado(item, false)"
                                                >
                                                    <v-icon>mdi-minus</v-icon>
                                                </v-btn>
                                            </div>

                                            <!-- Título do registro de comentários -->
                                            <div class="d-flex align-center mb-3 mt-2">

                                                <v-icon color="primary" class="mr-2">mdi-clipboard-text-outline</v-icon>
                                                <div 
                                                    class="font-weight-medium" 
                                                    style="color: #1976d2; font-size: 16px; line-height: 1.4;">
                                                    Comentários Chamado
                                                </div>
                                                <v-chip 
                                                    v-if="item.Comentarios && item.Comentarios.length > 0" 
                                                    class="ml-2" 
                                                    color="primary" 
                                                    size="small"
                                                >
                                                    {{ item.Comentarios.length }}
                                                </v-chip>
                                            </div>
                                            
                                            <v-table dense class="comentarios-table" style="table-layout: fixed; width: 100%;">

                                                <colgroup>
                                                    <col style="width: 50px;" />
                                                    <col style="width: 170px;" />
                                                    <col style="width: 170px;" />
                                                    <col style="width: 170px;" />
                                                    <col style="width: 200px;" />
                                                    <col style="width: auto;" />
                                                </colgroup>

                                                <thead>
                                                    <tr>
                                                        <th>Editar</th>
                                                        <th>Código</th>
                                                        <th>Comentou</th>
                                                        <th>Lido Por</th>
                                                        <th>Data</th>
                                                        <th>Comentário</th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    <tr
                                                        v-for="registroComentarios in item.Comentarios"
                                                        :key="registroComentarios.id"
                                                        @click="linhaComentarioSelecionada = registroComentarios.id"
                                                        :class="{ 'linha-comentario-selecionada': linhaComentarioSelecionada === registroComentarios.id }"
                                                    >
                                                        <td>
                                                            <v-tooltip 
                                                                text="Visualizar Comentário" 
                                                                location="bottom"
                                                                >
                                                                <template #activator="{ props }">
                                                                    <v-icon
                                                                        v-bind="props"
                                                                        :color="registroComentarios.comentarioLido === 1 ? 'green' : 'red'" 
                                                                        size="20"
                                                                        @click.stop="criarEditarComentario(item, registroComentarios.id, 'listaComentarios')"
                                                                        style="cursor: pointer;"
                                                                    >
                                                                        mdi-pencil
                                                                    </v-icon>
                                                                </template>
                                                            </v-tooltip>
                                                        </td>

                                                        <td style="text-align:center;">{{ registroComentarios.id }}</td>
                                                        <td style="text-align:center;">{{ registroComentarios.nomeQuemComentou }}</td>
                                                        <td style="text-align:center;">{{ registroComentarios.nomeQuemLeu }}</td>
                                                        <td style="text-align:center;">{{ proxy.$formataDataBrasil(registroComentarios.dataComentario) }}</td>
                                                        <td style="text-align:center;" v-html="registroComentarios.comentario"></td>

                                                    </tr>

                                                    <tr v-if="!item.Registros || item.Registros.length === 0">
                                                        <td colspan="5" class="text-center text-grey">
                                                            Não existe nenhum registro desse chamado.
                                                        </td>
                                                    </tr>

                                                </tbody>

                                            </v-table>

                                        </div>

                                    </td>

                                </tr>

                            </transition>

                            <!-- Linha expandida com registros chamado -->
                            <transition name="expand">

                                <tr v-if="linhaRegistrosChamados(item.idChamado)">
                                    
                                    <td colspan="12" class="pa-0" style="background-color: #f5f5f5;">

                                        <div style="padding-left: 30px;">

                                            <div style="position: relative;">
                                                <v-btn
                                                    icon
                                                    color="blue"
                                                    size="x-small"
                                                    style="position: absolute; top: -2px; right: 8px; z-index: 10;"
                                                    @click.stop="fechaRegistrosChamado"
                                                >
                                                <v-icon>mdi-minus</v-icon>
                                                </v-btn>
                                            </div>

                                            <!-- Título do registro de chamados -->
                                            <div class="d-flex align-center mb-3 mt-2">

                                                <v-icon color="primary" class="mr-2">mdi-eye</v-icon>
                                                <div 
                                                    class="font-weight-medium" 
                                                    style="color: #1976d2; font-size: 16px; line-height: 1.4;">
                                                    Registros Chamado
                                                </div>
                                                <v-chip 
                                                    v-if="item.Registros && item.Registros.length > 0" 
                                                    class="ml-2" 
                                                    color="primary" 
                                                    size="small"
                                                >
                                                    {{ item.Registros.length }}
                                                </v-chip>
                                            </div>

                                            <v-table 
                                                dense 
                                                class="comentarios-table" 
                                                style="table-layout: fixed; width: 100%; font-size: 11px;">

                                                <colgroup>
                                                    <col style="width: 50px;" />
                                                    <col style="width: 100px;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                    <col style="width: auto;" />
                                                </colgroup>

                                                <thead>
                                                    <tr>
                                                        <th class="text-center">Detalhes</th>
                                                        <th class="text-center">Código</th>
                                                        <th class="text-center">Cliente</th>
                                                        <th class="text-center">Status</th>
                                                        <th class="text-center">Versão</th>
                                                        <th class="text-center">Data Registro</th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    <tr
                                                        v-for="registroChamado in item.Registros"
                                                        :key="registroChamado.id"
                                                        @click="linhaRegistroSelecionada = registroChamado.id"
                                                        :class="{ 'linha-registro-chamado-selecionada': linhaRegistroSelecionada === registroChamado.id }"
                                                    >
                                                        <td>
                                                            <v-tooltip 
                                                                text="Ler Registro" 
                                                                location="bottom"
                                                                >
                                                                <template #activator="{ props }">
                                                                    <v-icon
                                                                        v-bind="props"
                                                                        color="black"
                                                                        size="20"
                                                                        @click.stop="lerRegistroChamado(item, registroChamado.id, 'listaRegistroChamado')"
                                                                        style="cursor: pointer;"
                                                                    >
                                                                        mdi-magnify
                                                                    </v-icon>
                                                                </template>
                                                            </v-tooltip>
                                                        </td>

                                                        <td style="text-align:center;">{{ registroChamado.id }}</td>
                                                        <td style="text-align:center;">{{ registroChamado.nomeFantasia }}</td>
                                                        <td style="text-align:center;">{{ registroChamado.status }}</td>
                                                        <td style="text-align:center;">{{ registroChamado.versaoChamado }}</td>
                                                        <td style="text-align:center;">{{ proxy.$formataDataBrasil(registroChamado.dataRegistro) }}</td>

                                                    </tr>

                                                    <tr v-if="!item.Registros || item.Registros.length === 0">
                                                        <td colspan="5" class="text-center text-grey">
                                                            Não existe nenhum registro para este chamado.
                                                        </td>
                                                    </tr>

                                                </tbody>

                                            </v-table>
                                        
                                        </div>

                                    </td>

                                </tr>

                            </transition>

                        </template>

                    </v-data-table-server>

                </v-card>

            </v-container>
    
            
            <!-- FORMLÁRIOS MODAIS DO SISTEMA DE CHAMADOS -->
            
            <!-- Modal para exibir os dados do chamado -->
            <v-dialog v-model="modalDadosChamado.visible" max-width="80%" persistent>

                <!-- Card que contém os dados do chamado e só é mostrado quando existem dados na variável modalDadosChamado -->
                <v-card v-if="modalDadosChamado.data">
                    
                    <!-- Barra superior modal chamados -->
                    <v-toolbar color="primary" dark>

                        <v-toolbar-title>
                            <v-icon left>mdi-clipboard-text-outline</v-icon>
                            Dados Chamado: ({{ modalDadosChamado.data.idChamado }})
                        </v-toolbar-title>
                        
                        <v-spacer></v-spacer>
                        <v-btn icon @click="fecharModalChamados">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                    </v-toolbar>

                    <v-card-text>

                        <!-- Formulário para editar os dados do chamado -->
                        <v-form>

                            <v-row dense>

                                <!-- Campo que mostra nome do cliente ligado aos dados pela propriedade v-model -->                                    
                                <v-col cols="12" sm="6">

                                    <v-text-field 
                                        ref="textAreaNomeCliente"
                                        v-model="modalDadosChamado.data.Cliente" 
                                        label="Cliente"
                                        outlined
                                        :disabled="desabilitarCampoCliente"
                                        @input="autoCompletaNomeCliente"
                                        @keyup="manipuladorKeyUp"
                                        @keydown="handleKeyDown"
                                        :clearable="true"
                                        @click:clear="limparDadosEmpresaCliente"
                                        :class="{ 'campos-desabilitados': modalDadosChamado.data.Cliente }"
                                    >
                                    </v-text-field>
                                    
                                    <!-- Lista de sugestões -->
                                    <v-list 
                                        v-if="sugestoes.length && !desabilitarCampoCliente" 
                                        style="max-height: 200px; overflow-y: auto; position: absolute; z-index: 100; width: calc(100% - 32px); background: white;"
                                        >
                                        <v-list-item
                                            v-for="(cliente, index) in sugestoes"
                                            :key="cliente.id"
                                            @click="selecionarCliente(cliente)"
                                            :style="{ backgroundColor: index === indiceSelecionado ? '#e3f2fd' : 'white' }"
                                        >
                                            <v-list-item-title>
                                            {{ cliente.nome }}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                    
                                </v-col>

                                <!-- Lista de contatos do cliente. Seleciona o contato apontando por idColaborador  -->                                   
                                <v-col cols="12" sm="6">

                                    <v-select
                                        ref="textAreaSolicitante"
                                        v-model="modalDadosChamado.data.idAbriuChamado"
                                        :items="modalDadosChamado.data.nomeColaboradorCliente"
                                        :disabled="desabilitarCampoCliente"
                                        label="Solicitante"
                                        item-title="title"
                                        item-value="value"
                                        :clearable="true"
                                        :class="{ 'campos-desabilitados': modalDadosChamado.data.Cliente }"
                                    ></v-select>
                                    
                                </v-col>

                            </v-row>   

                            <v-row dense>

                                <!-- Lista de produtos. Seleciona o produto apontado por idProduto -->                                    
                                <v-col cols="12" sm="4">

                                    <v-select
                                        v-model="modalDadosChamado.data.idProduto"
                                        :items="modalDadosChamado.data.produtos"
                                        label="Produto"
                                        item-title="title"
                                        item-value="value"
                                        :clearable="true"
                                    ></v-select>
                                
                                </v-col>

                                <!-- Lista de tipos de chamados. -->
                                <v-col cols="12" sm="4">

                                    <v-select
                                        v-model="modalDadosChamado.data.idTipoChamado"
                                        :items="modalDadosChamado.data.tipoChamados"
                                        :label="loginStore.emissoraTelevisao === 1 ? 'Tipo Avaria' : 'Tipo Chamado'"
                                        item-title="title"
                                        item-value="value"
                                        :clearable="true"
                                    ></v-select>
                                        
                                </v-col>

                                <!-- Campo contendo a seleção de prioridade -->
                                <v-col cols="12" md="4">
                                    <v-select
                                        v-model="modalDadosChamado.data.prioridade"
                                        :items="dadosPrioridade"
                                        label="Prioridade"
                                        item-title="text"
                                        item-value="value"
                                    ></v-select>
                                </v-col>
                                
                            
                            </v-row>

                            <!-- Solicitação do chamado -->                                                                    
                            <v-row dense>

                                <v-col cols="12" md="12">
                                
                                    <div class="quill-editor-wrapper quill-editor-redimensionavel">
                                        <label class="quill-label">Descreva Sua Solicitação Mais Detalhadamente Possível...</label>

                                        <QuillEditor
                                            v-model:content="modalDadosChamado.data.solicitado"
                                            content-type="html"
                                            theme="snow"
                                            :disabled="desabilitarCampoSolicitado"
                                            :toolbar="[
                                                ['bold', 'italic', 'underline', 'strike'],
                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }]
                                            ]"
                                            :class="{ 'campos-desabilitados': modalDadosChamado.data.Cliente }"
                                        />
                                    </div>
                                
                                </v-col>

                            </v-row>

                            <!-- Select que mostra a lista de status. Seleciona o status apontado por status -->                                
                            <v-row dense>

                                <v-col cols="12" sm="3">

                                    <v-select
                                        ref="textAreaStatus"                                             
                                        v-model="modalDadosChamado.data.status"
                                        :items="dadosStatus"
                                        label="Status"
                                        item-title="text"
                                        item-value="value"
                                    ></v-select>
                                                        
                                </v-col>
                                
                                <!-- Campo contendo a data e hora da previsão de conclusão  -->
                                <v-col 
                                    v-if="modalDadosChamado.data.status == 'EXECUCAO'" cols="12" md="3"
                                    >
                                    
                                    <v-menu v-model="vmodelCalendarioPrevisaoConclusao" :close-on-content-click="false">

                                        <!-- Campo contendo a data e hora de abertura -->
                                        <template v-slot:activator="{ props }">

                                            <v-text-field
                                                :model-value="modalDadosChamado.data.dataPrevisaoConclusao"
                                                label="Previsão Conclusão"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="props" 
                                                :clearable="true"
                                            ></v-text-field>
                                        
                                        </template>

                                        <!-- Componente para selecionar data e hora abertura -->
                                        <v-card>
                                            
                                            <v-date-picker
                                                v-model="dataPrevisaoConclusao"
                                                :timezone="'America/Sao_Paulo'"
                                                locale="pt-BR"
                                                :title= "'Selecione uma data'"
                                                @update:modelValue="mostrarRelogio = true"                                                                        
                                            ></v-date-picker>

                                            <v-time-picker
                                                v-if="mostrarRelogio"
                                                v-model="horaSelecionadaPrevisaoConclusao"
                                                format="24hr"
                                                locale="pt-BR"
                                                :title= "'Selecione um horário'"
                                                @update:modelValue="horaPrevisaoConclusao = $event"
                                            ></v-time-picker>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text @click="fecharCalendario">Cancelar</v-btn>
                                                <v-btn color="primary" @click.native.stop="confirmaDatas(6, dataPrevisaoConclusao, horaPrevisaoConclusao)">Confirmar</v-btn>
                                            </v-card-actions>

                                        </v-card>

                                    </v-menu>

                                </v-col>
                                
                                
                                <!-- Lista de recursos que trabalharam no chamado -->
                                <v-col 
                                    cols="12" 
                                    :sm="modalDadosChamado.data.status == 'EXECUCAO' ? 6 : 9"
                                >

                                    <v-select
                                        v-model="modalDadosChamado.data.idColaboradorSuporte"
                                        :items="modalDadosChamado.data.nomeColaboradorSuporte"
                                        item-text="title"
                                        item-value="value"
                                        multiple
                                        chips
                                        :clearable="true"
                                        :loading="carregandoUsuarios"
                                        label="Recursos Técnicos"
                                    ></v-select>

                                </v-col>

                            </v-row>
                            
                            <!-- Mostra campo descrição da pendência e calendário de previsão se houver dados no campo pendencia -->
                            <v-row dense 
                                v-show="modalDadosChamado.data.pendencia  || 
                                        modalDadosChamado.data.status == 'PENDENTE' ||
                                        modalDadosChamado.data.status == 'PENDENTE CLIENTE'">

                                <!-- Campo que mostra o que foi pendente -->                                    
                                <v-col cols="12" md="9">

                                    <v-textarea
                                        ref="textAreaPendente"
                                        v-model="modalDadosChamado.data.pendencia" 
                                        label="Pendência"
                                        placeholder="Descreva Motivo da Pendência..."
                                        auto-grow
                                        rows="1"
                                        :clearable="true"
                                        variant="filled"
                                        >
                                    </v-textarea>
                                    
                                </v-col>

                                <!-- Calendário com a previsão de tempo de resolução da pendencia -->                                    
                                <v-col cols="12" md="3">

                                    <!-- Campo contendo a data e hora de previsão -->
                                    <v-menu 
                                        v-model="vmodelCalendarioPrevisao" 
                                        :close-on-content-click="false">

                                        <!-- Campo contendo a data e hora de previsão -->
                                        <template v-slot:activator="{ props }">

                                            <v-text-field
                                                :model-value="modalDadosChamado.data.dataPrevisaoPendencia"
                                                label="Previsão Conclusão"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="props"
                                                :clearable="true"
                                            ></v-text-field>
                                        
                                        </template>

                                        <!-- Componente para selecionar data e hora previsão -->
                                        <v-card>
                                            
                                            <v-date-picker
                                                v-model="dataSelecionadaPrevisao"
                                                @update:modelValue="mostrarRelogio = true"
                                                locale="pt-BR"
                                                :title= "'Selecione uma data'"
                                            ></v-date-picker>

                                            <v-time-picker
                                                v-if="mostrarRelogio"
                                                v-model="horaSelecionadaPrevisao"
                                                format="24hr"
                                                locale="pt-BR"
                                                :title= "'Selecione um horário'"
                                                @update:modelValue="horaSelecionadaPrevisao = $event"
                                            ></v-time-picker>
                                        
                                        </v-card>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn text @click="fecharCalendario">Cancelar</v-btn>
                                            <v-btn color="primary" @click.native.stop="confirmaDatas(2, dataSelecionadaPrevisao, horaSelecionadaPrevisao)">Confirmar</v-btn>
                                        </v-card-actions>

                                    </v-menu>
                                
                                </v-col>
                                
                            </v-row>

                            <!-- Mostra campo executado, tempo execução e custo chamado se houver dados no campo executado -->
                            <v-row dense 
                                v-show="modalDadosChamado.data.executado || 
                                      modalDadosChamado.data.status == 'CONCLUIDO'">

                                <!-- Campo que mostra o que foi executado -->                                    
                                <v-col cols="12" md="8">

                                    <v-textarea
                                        ref="textAreaExecutado"
                                        v-model="modalDadosChamado.data.executado"
                                        label="Executado"
                                        placeholder="Descreva o que foi executado..."
                                        auto-grow
                                        rows="1"
                                        :clearable="true"
                                        variant="filled"
                                        >
                                    </v-textarea>

                                </v-col>

                                <!-- Campo que mostra o tempo de execução -->
                                <v-col cols="12" md="2">

                                    <v-text-field
                                        v-model="modalDadosChamado.data.tempoExecucao"
                                        label="Tempo Execução"
                                        placeholder="HHH:mm"
                                        variant="filled"
                                        :clearable="true"
                                        maxlength="6"
                                    />
                                </v-col>

                                <!-- Campo que mostra o custo do chamado -->
                                <v-col cols="12" sm="2">

                                    <v-text-field
                                        v-model="modalDadosChamado.data.custoChamado"
                                        label="Custo Chamado"
                                        placeholder="0,00"
                                        type="text"
                                        variant="filled"
                                        @input="formatarCusto($event, 'chamado')"
                                    />

                                </v-col>
                            
                            </v-row>

                            <!-- Mostra campo orçamento e custo e houver dados no campo descricaoOrcamento -->
                            <v-row dense 
                                v-if="modalDadosChamado.data.descricaoOrcamento ||
                                      modalDadosChamado.data.status == 'ORCAMENTO' ||
                                      modalDadosChamado.data.status == 'ORCAMENTO APROVADO' ||
                                      modalDadosChamado.data.status == 'ORCAMENTO REJEITADO'">

                                <!-- Campo para entrar com a descrição do orçamento -->                                    
                                <v-col cols="12" md="8">

                                    <v-textarea
                                        ref="textAreaOrcamento"
                                        v-model="modalDadosChamado.data.descricaoOrcamento" 
                                        label="Descrição Orçamento"
                                        placeholder="Descreva o que será feito..."
                                        auto-grow
                                        rows="1"
                                        :clearable="true"
                                        variant="filled"
                                        >
                                    </v-textarea>
                                    
                                </v-col>

                                <!-- Campo para entrar com o tempo em horas -->                                    
                                <v-col cols="12" sm="2">

                                    <v-text-field
                                        v-model="modalDadosChamado.data.horasDesenvolvimento"
                                        label="Tempo Horas"
                                        type="text" 
                                        variant="filled" 
                                        maxlength="4"
                                        @keypress="filtroNumerosDesenvolvimento"
                                        @input="calcuolarCustoOrcamento"
                                    />

                                </v-col>

                                <!-- Campo para entrar com o custo do orçamento -->                                    
                                <v-col cols="12" sm="2">

                                    <v-text-field
                                        v-model="modalDadosChamado.data.custoOrcamento"
                                        label="Custo Orçamento"
                                        placeholder="0,00"
                                        type="text"
                                        variant="filled"
                                        @input="formatarCusto($event, 'orcamento')"
                                        :clearable="true"
                                    />

                                </v-col>

                            </v-row>
                            
                            <v-row dense>

                                <!-- Campo contendo a data e hora de abertura -->
                                <v-col cols="12" md="3">
                                    
                                    <v-menu v-model="vmodelCalendarioAberto" :close-on-content-click="false">

                                        <!-- Campo contendo a data e hora de abertura -->
                                        <template v-slot:activator="{ props }">

                                            <v-text-field
                                                :model-value="modalDadosChamado.data.dataAbertura"
                                                label="Abertura"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="props" 
                                                :clearable="true"
                                            ></v-text-field>
                                        
                                        </template>

                                        <!-- Componente para selecionar data e hora abertura -->
                                        <v-card>
                                            
                                            <v-date-picker
                                                v-model="dataSelecionadaAbertura"
                                                :timezone="'America/Sao_Paulo'"
                                                locale="pt-BR"
                                                :title= "'Selecione uma data'"
                                                @update:modelValue="mostrarRelogio = true"                                                                        
                                            ></v-date-picker>

                                            <v-time-picker
                                                v-if="mostrarRelogio"
                                                v-model="horaSelecionadaAbertura"
                                                format="24hr"
                                                locale="pt-BR"
                                                :title= "'Selecione um horário'"
                                                @update:modelValue="horaSelecionadaAbertura = $event"
                                            ></v-time-picker>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text @click="fecharCalendario">Cancelar</v-btn>
                                                <v-btn color="primary" @click.native.stop="confirmaDatas(1, dataSelecionadaAbertura, horaSelecionadaAbertura)">Confirmar</v-btn>
                                            </v-card-actions>

                                        </v-card>

                                    </v-menu>

                                </v-col>
                                
                                <!-- Campo que mostra a data e hora da execução -->                                    
                                <v-col cols="12" md="3">

                                    <v-menu v-model="vmodelCalendarioExecucao" :close-on-content-click="false">

                                        <!-- Campo contendo a data e hora de execução -->
                                        <template v-slot:activator="{ props }">

                                            <v-text-field
                                                :model-value="modalDadosChamado.data.dataExecucao"
                                                label="Execução"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="props"
                                                :clearable="true"
                                            ></v-text-field>
                                        
                                        </template>

                                        <!-- Componente para selecionar data e hora execução -->
                                        <v-card>
                                            
                                            <v-date-picker
                                                v-model="dataSelecionadaExecucao"
                                                @update:modelValue="mostrarRelogio = true"
                                                locale="pt-BR"
                                                :title= "'Selecione uma data'"
                                            ></v-date-picker>

                                            <v-time-picker
                                                v-if="mostrarRelogio"
                                                v-model="horaSelecionadaExecucao"
                                                format="24hr"
                                                locale="pt-BR"
                                                :title= "'Selecione um horário'"
                                                @update:modelValue="horaSelecionadaExecucao = $event"
                                            ></v-time-picker>
                                        
                                        </v-card>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn text @click="fecharCalendario">Cancelar</v-btn>
                                            <v-btn color="primary" @click.native.stop="confirmaDatas(3, dataSelecionadaExecucao, horaSelecionadaExecucao)">Confirmar</v-btn>
                                        </v-card-actions>

                                    </v-menu>
                                
                                </v-col>    

                                <!-- Campo contendo a data e hora de pendência -->
                                <v-col cols="12" md="3">
                                    
                                    <v-menu v-model="vmodelCalendarioPendencia" :close-on-content-click="false">

                                        <!-- Campo contendo a data e hora de pendência -->
                                        <template v-slot:activator="{ props }">

                                            <v-text-field
                                                :model-value="modalDadosChamado.data.dataPendencia"
                                                label="Pendência"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="props"
                                                :clearable="true"
                                            ></v-text-field>
                                        
                                        </template>

                                        <!-- Componente para selecionar data e hora pendência -->
                                        <v-card>
                                            
                                            <v-date-picker
                                                v-model="dataSelecionadaPendencia"
                                                @update:modelValue="mostrarRelogio = true"                                    
                                                locale="pt-BR"
                                                :title= "'Selecione uma data'"
                                            ></v-date-picker>

                                            <v-time-picker
                                                v-if="mostrarRelogio"
                                                v-model="horaSelecionadaPendencia"
                                                format="24hr"
                                                locale="pt-BR"
                                                :title= "'Selecione um horário'"
                                                @update:modelValue="horaSelecionadaPendencia = $event"
                                            ></v-time-picker>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text @click="fecharCalendario">Cancelar</v-btn>
                                                <v-btn color="primary" @click.native.stop="confirmaDatas(5, dataSelecionadaPendencia, horaSelecionadaPendencia)">Confirmar</v-btn>
                                            </v-card-actions>
                                        
                                        </v-card>

                                    </v-menu>

                                </v-col>
                                           
                                <!-- Campo contendo a data e hora de conclusão -->
                                <v-col cols="12" md="3">

                                    <v-menu v-model="vmodelCalendarioConclusao" :close-on-content-click="false">

                                        <!-- Campo contendo a data e hora de conclusão -->
                                        <template v-slot:activator="{ props }">

                                            <v-text-field
                                                :model-value="modalDadosChamado.data.dataConclusao"
                                                label="Concluído"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="props" 
                                                :clearable="true"
                                            ></v-text-field>
                                        
                                        </template>

                                        <!-- Componente para selecionar data e hora conclusão -->
                                        <v-card>
                                            
                                            <v-date-picker
                                                v-model="dataSelecionadaConcluido"
                                                @update:modelValue="mostrarRelogio = true"
                                                locale="pt-BR"
                                                :title= "'Selecione uma data'"
                                            ></v-date-picker>

                                            <v-time-picker
                                                v-if="mostrarRelogio"
                                                v-model="horaSelecionadaConcluido"
                                                format="24hr"
                                                locale="pt-BR"
                                                :title= "'Selecione um horário'"
                                                @update:modelValue="horaSelecionadaConcluido = $event"
                                            ></v-time-picker>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text @click="fecharCalendario">Cancelar</v-btn>
                                                <v-btn color="primary" @click.native.stop="confirmaDatas(4, dataSelecionadaConcluido, horaSelecionadaConcluido)">Confirmar</v-btn>
                                            </v-card-actions>

                                        </v-card>

                                    </v-menu>

                                </v-col>

                            </v-row>

                            <v-row dense>

                                <!-- Campo contendo a tag chamado -->
                                <v-col cols="12" md="12">

                                    <v-textarea
                                        v-model="modalDadosChamado.data.tagChamado"
                                        label="Tag Chamado"
                                        auto-grow
                                        rows="1"
                                        :clearable="true"
                                        variant="filled"
                                        >
                                    </v-textarea>

                                </v-col>
                                
                            </v-row>                            

                            <!-- Campo contendo os arquivos anexos ao chamado -->
                            <v-row dense>

                                <v-col cols="12">

                                    <v-file-input
                                        v-model="mostraAnexosChamado"
                                        multiple
                                        label="Selecione os arquivos"
                                        prepend-icon="mdi-paperclip"
                                        @change="manipuladorArquivoChamado"
                                        :loading="fazendoUploadChamado"
                                        :disabled="fazendoUploadChamado"
                                        class="ma-4"
                                        :clearable=false
                                    >
                                        <template v-slot:selection="{ file }">

                                            <v-chip
                                            
                                                v-for="(fileObj, index) in arquivosAnexadosChamado"
                                                :key="fileObj.uniqueId || index"
                                                close
                                                class="ma-1"
                                                :color="fileObj.isExisting ? 'primary' : 'default'"
                                            >
                                                {{ fileObj.displayName }}

                                                <!-- Ícone para remover o arquivo -->
                                                <v-icon
                                                    class="ml-2"
                                                    color="red"
                                                    size="18"
                                                    @click.stop="abreModalConfirmacao(index, 'chamado')"
                                                    style="cursor: pointer;"
                                                >
                                                    mdi-close-circle
                                                </v-icon>

                                                <!-- Ícone para download, se o arquivo já existir -->
                                                <v-icon 
                                                    v-if="fileObj.isExisting" 
                                                    class="ml-1"
                                                    color="blue"
                                                    size="18"
                                                    @click.stop="baixarAnexo(fileObj, 'anexos_chamados')"
                                                    style="cursor: pointer;"
                                                >
                                                    mdi-download
                                                </v-icon>

                                            </v-chip>
                                            
                                        </template>

                                    </v-file-input>

                                    <!-- Barra de mensagem verde -->
                                    <v-alert
                                        v-model="showMessageChamado"
                                        :type="messageType"
                                        density="compact"
                                        variant="tonal"
                                        class="mt-2 mb-4 mx-4"
                                    >
                                        {{ messageText }}
                                    </v-alert>
                                    
                                    <v-progress-linear
                                        v-if="fazendoUploadChamado"
                                        v-model="uploadProgressChamado"
                                        color="light-blue"
                                        height="10"
                                        class="ma-4"
                                    >
                                    </v-progress-linear>

                                    <v-alert
                                        v-if="uploadMessageChamado"
                                        :type="isError ? 'error' : 'success'"
                                        class="ma-4"
                                    >
                                        {{ uploadMessageChamado }}
                                    </v-alert>

                                </v-col>

                            </v-row>

                            <v-row>

                                <v-col>
                                    <v-switch
                                        v-model="modalDadosChamado.data.envioEmailCliente"
                                        :label="modalDadosChamado.data.envioEmailCliente ? 'Notificar Cliente Por E-mail' : 'Não Notificar'"
                                        :color="modalDadosChamado.data.envioEmailCliente ? 'green' : 'red'"
                                    />
                                </v-col>

                            </v-row>

                        </v-form>

                        <!-- Acordeon com lista de comentarios da empresa -->
                        <v-expansion-panels 
                            v-model="acordeonComentarios" 
                            v-show="mostraAcordeonComantarios > 0" 
                            id="acordeonComentarios" 
                            class="mt-4  mb-4">

                            <v-expansion-panel>

                                <v-expansion-panel-title>
                                    Comentários Chamado
                                </v-expansion-panel-title>

                                <v-expansion-panel-text>

                                    <v-row class="mb-4" align="center" justify="end">

                                        <!-- Botão para criar novo colaborador -->
                                        <v-col cols="auto">
                                            <v-btn
                                                icon
                                                large
                                                class="rounded-button"
                                                style="background-color: #4CAF50;"
                                                @click="criarEditarComentario(item, 0, 'modalChamados')"
                                            >
                                                <v-icon color="white">mdi-plus</v-icon>
                                            </v-btn>
                                        </v-col>

                                    </v-row>
                                    
                                    <v-data-table-server
                                        v-model:options="opcoesTabelaComentarios"
                                        :headers="headersComentariosAcordeon"
                                        :items="listaComentariosAcordeon"
                                        :loading="carregandoComentariosAcordeon"
                                        :items-length="totalComentariosAcordeon"
                                        @update:options="carregarListaComentariosAcordeon"
                                    >
                                        <template v-slot:item.funcoes="{ item }">
                        
                                            <!-- Ícone de atalho para editar chamado -->
                                            <v-tooltip text="Visualizar Comentário" location="bottom">

                                                <template #activator="{ props }">
                                                    
                                                    <v-icon
                                                        v-bind="props"
                                                        :color="item.comentarioLido === 1 ? 'green' : 'red'" 
                                                        size="24" 
                                                        @click="criarEditarComentario(item, item.id, 'modalChamados')"
                                                        style="cursor: pointer; margin-right: 8px;"
                                                    >
                                                    mdi-pencil
                                                    </v-icon>

                                                </template>

                                            </v-tooltip>
                                            
                                        </template>
                                        
                                        <template #item.ativo="{ item }">
                                            <span :class="item.ativo === 1 ? 'text-green' : 'text-red'">
                                            {{ item.ativo === 1 ? 'Ativo' : 'Inativo' }}
                                            </span>
                                        </template>

                                        <!-- Sobrescreve a coluna Lido para formatar -->
                                        <template #[`item.comentarioLido`]="{ item }">
                                            <v-chip 
                                                :color="item.comentarioLido ? 'success' : 'error'" 
                                                size="small"
                                            >
                                                {{ item.comentarioLido ? 'Sim' : 'Não' }}
                                            </v-chip>
                                        </template>
                                        
                                    </v-data-table-server>

                                </v-expansion-panel-text>

                            </v-expansion-panel>

                        </v-expansion-panels>
                    
                    </v-card-text>

                    <!-- Botões de funções retornar, salvar, salvar e retornar e salvar novo-->
                    <v-card-actions class="flex-wrap">

                        <v-spacer class="hidden-sm-and-down" />

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            style="background-color: orange; color: white;"
                            @click="fecharModalChamados"
                            >
                            <v-icon left>mdi-chevron-left</v-icon>
                            Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            style="background-color: #2196F3; color: white;"
                            @click="salvaChamado('salvar')"
                            >
                            <v-icon left color="white">mdi-update</v-icon>
                            Salvar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            outlined
                            style="background-color: white; border: 2px solid orange; color: orange;"
                            @click="salvaChamado('salvar-retornar')"
                            >
                            <v-icon left color="orange">mdi-update</v-icon>
                            Salvar e Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            outlined
                            style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                            @click="salvaChamado('salvar-novo')"
                            >
                            <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                            Salvar e Novo
                        </v-btn>

                    </v-card-actions>

                </v-card>

            </v-dialog>
            
            <!-- Modal para exibir comentarios -->
            <v-dialog v-model="modalDadosComentario.visible" max-width="50%" persistent>

                <!-- Card que contém os dados do chamado e só é mostrado quando existem dados na variável modalDadosComentario -->
                <v-card v-if="modalDadosComentario.data">
                    
                    <!-- Barra superior modal de registro de chamados -->
                    <v-toolbar color="primary" dark>

                        <v-toolbar-title class="wrap-title">
                            <div style="white-space: normal; font-size: 14px;">
                                <v-icon left>mdi-handshake</v-icon>
                                Comentário Chamado: {{ '(' + modalDadosComentario.data.idChamado + ')  Feito Em: ' + modalDadosComentario.data.dataComentario }}
                            </div>
                        </v-toolbar-title>
                        
                        <v-spacer></v-spacer>
                        <v-btn icon @click="fecharModalComentario">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                    </v-toolbar>
                    
                    <!-- Formulário para editar os dados do chamado -->                        
                    <v-card-text>

                        <!-- Campo que mostra o que foi comentado -->
                        <div class="quill-editor-wrapper quill-editor-redimensionavel">

                            <label class="quill-label">Descreva Seu Comentário...</label>

                            <QuillEditor
                                v-model:content="modalDadosComentario.data.textoComentario"
                                content-type="html"
                                theme="snow"
                                :toolbar="[
                                    ['bold', 'italic', 'underline', 'strike'],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
                                ]"
                                :class="{ 'campos-desabilitados': modalDadosChamado.data.Cliente }"
                            />
                        </div>
                    
                    </v-card-text>
                    
                     <v-row dense>

                        <!-- File input para upload de arquivos de comentários -->
                        <v-col cols="9">

                            <v-file-input
                                v-model="mostraAnexosComentario"
                                multiple
                                label="Selecione os arquivos"
                                prepend-icon="mdi-paperclip"
                                @change="manipuladorArquivoComentario"
                                :loading="fazendoUploadComentario"
                                :disabled="fazendoUploadComentario"
                                class="ma-4"
                                :clearable=false
                            >
                                <template v-slot:selection="{ file }">

                                    <v-chip
                                    
                                        v-for="(fileObj, index) in arquivosAnexadosComentario"
                                        :key="fileObj.uniqueId || index"
                                        close
                                        class="ma-1"
                                        :color="fileObj.isExisting ? 'primary' : 'default'"
                                    >
                                        {{ fileObj.displayName }}

                                        <!-- Ícone para remover o arquivo -->
                                        <v-icon
                                            class="ml-2"
                                            color="red"
                                            size="18"
                                            @click.stop="abreModalConfirmacao(index, 'comentario')"
                                            style="cursor: pointer;"
                                        >
                                            mdi-close-circle
                                        </v-icon>

                                        <!-- Ícone para download, se o arquivo já existir -->
                                        <v-icon 
                                            v-if="fileObj.isExisting" 
                                            class="ml-1"
                                            color="blue"
                                            size="18"
                                            @click.stop="baixarAnexo(fileObj,'anexos_comentarios')"
                                            style="cursor: pointer;"
                                        >
                                            mdi-download
                                        </v-icon>

                                    </v-chip>
                                    
                                </template>

                            </v-file-input>

                            <!-- Barra de mensagem verde -->
                            <v-alert
                                v-model="showMessageComentario"
                                :type="messageType"
                                density="compact"
                                variant="tonal"
                                class="mt-2 mb-4 mx-4"
                            >
                                {{ messageText }}
                            </v-alert>
                            
                            <v-progress-linear
                                v-if="fazendoUploadComentario"
                                v-model="uploadProgressComentario"
                                color="light-blue"
                                height="10"
                                class="ma-4"
                            >
                            </v-progress-linear>

                            <v-alert
                                v-if="uploadMessageComentario"
                                :type="isError ? 'error' : 'success'"
                                class="ma-4"
                            >
                                {{ uploadMessageComentario }}
                            </v-alert>

                        </v-col>

                        <v-col cols="12" sm="2">
                            <v-switch
                                v-model="modalDadosComentario.data.comentarioLido"
                                :model-value="modalDadosComentario.data.comentarioLido === 1"
                                @update:model-value="val => modalDadosComentario.data.comentarioLido = val ? 1 : 0"
                                :label="modalDadosComentario.data.comentarioLido ? 'Lido' : 'Não Lido'"
                                :color="modalDadosComentario.data.comentarioLido ? 'green' : 'grey'"                                
                            />                            
                        </v-col>

                    </v-row>

                    <v-card-actions>
                        <v-btn 
                            color="success" 
                            class="mt-4" 
                            @click="salvaComentario"
                            :disabled="desabilitarSalvarModalComentarios"
                        >Salvar</v-btn>
                        <v-btn color="red" class="mt-4" @click="fecharModalComentario">Fechar</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>

            <!-- Modal para exibir registro de chamados -->
            <v-dialog v-model="modalRegistroChamado.visible" max-width="80%" persistent>

                <!-- Card que contém os dados do chamado e só é mostrado quando existem dados na variável modalRegistroChamado -->
                <v-card v-if="modalRegistroChamado.data">
                    
                    <!-- Barra superior modal de registro de chamados -->
                    <v-toolbar color="primary" dark>

                        <v-toolbar-title>
                            <v-icon left>mdi-handshake</v-icon>
                            Registro Chamado: ({{ modalRegistroChamado.data.idChamado }}) Versão: ({{ modalRegistroChamado.data.versaoChamado }})
                        </v-toolbar-title>
                        
                        <v-spacer></v-spacer>
                        <v-btn icon @click="fecharModalRegistroChamado">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                    </v-toolbar>

                    <v-card-text>

                        <!-- Formulário para editar os dados do chamado -->
                        <v-form>

                            <v-row dense>

                                <v-col cols="12" sm="6">

                                    <!-- Campo que mostra nome do cliente ligado aos dados pela propriedade v-model -->
                                    <v-text-field 
                                        v-model="modalRegistroChamado.data.nomeFantasia" 
                                        label="Cliente"
                                        outlined
                                        :items="clientes"                                        
                                    >
                                    </v-text-field>
                                    
                                </v-col>

                                <v-col cols="12" sm="6">

                                    <!-- Campo que mostra nome de quem abriu o chamado -->
                                    <v-text-field 
                                        v-model="modalRegistroChamado.data.nomeColaboradorCliente" 
                                        label="Aberto Por"
                                        outlined
                                        :items="clientes"
                                    >
                                    </v-text-field>
                                    
                                </v-col>

                            </v-row>   

                            <v-row dense>

                                <v-col cols="12" sm="6">

                                    <!-- Campo que mostra nome do produto -->
                                    <v-text-field 
                                        v-model="modalRegistroChamado.data.nomeProduto" 
                                        label="Produto"
                                        outlined
                                        :items="clientes"
                                    >
                                    </v-text-field>
                                
                                </v-col>

                                <v-col cols="12" sm="6">

                                    <!-- Campo que mostra tipo de chamado -->
                                    <v-text-field 
                                        v-model="modalRegistroChamado.data.nomeTipoChamado" 
                                        label="Tipo Chamado"
                                        outlined
                                        :items="clientes"
                                    >
                                    </v-text-field>

                                </v-col>
                            
                            </v-row>

                            <v-row dense>

                                <v-col cols="12" md="10">
                                
                                    <!-- Campo que mostra o que foi solicitado -->
                                    <v-textarea
                                        v-model="modalRegistroChamado.data.solicitado"
                                        label="Solicitado"
                                        auto-grow
                                        rows="1"
                                        variant="filled"
                                    >
                                    </v-textarea>

                                </v-col>

                                <v-col cols="12" md="2">
                                
                                    <v-text-field
                                        v-model="modalRegistroChamado.data.prioridade"
                                        label="Tempo"
                                        placeholder="HHH:mm"
                                        variant="filled"
                                        maxlength="6"
                                    />                               
                                
                                </v-col>

                            </v-row>

                            <v-row dense>

                                <v-col cols="12" sm="3">

                                    <!-- Mostra status do chamado -->
                                    <v-text-field 
                                        v-model="modalRegistroChamado.data.status" 
                                        label="Status"
                                        outlined
                                        :items="clientes"
                                    >
                                    </v-text-field>

                                </v-col>

                                <v-col cols="12" sm="9">

                                    <v-text-field 
                                        v-model="modalRegistroChamado.data.colaboradoresSuporte" 
                                        label="Recurso Suporte"
                                        outlined
                                        :items="clientes"
                                    >
                                    </v-text-field>

                                </v-col>

                            </v-row>

                            <v-row dense>

                                <v-col cols="12" md="10">

                                    <!-- Campo que mostra o que foi pendente -->
                                    <v-textarea
                                        v-model="modalRegistroChamado.data.pendencia" 
                                        label="Pendência"
                                        auto-grow
                                        rows="1"
                                        variant="filled"
                                        >
                                    </v-textarea>
                                
                                </v-col>

                                <v-col cols="12" md="2">

                                    <v-text-field
                                        :model-value="modalRegistroChamado.data.dataPrevisaoPendencia"
                                        label="Previsão"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="props"
                                    ></v-text-field>
                                
                                </v-col>                               
                            
                            </v-row>
                            
                            <v-row dense>

                                <v-col cols="12" md="8">

                                    <!-- Campo que mostra o que foi executado -->
                                    <v-textarea
                                        v-model="modalRegistroChamado.data.executado"
                                        label="Executado"
                                        auto-grow
                                        rows="1"
                                        :clearable="true"
                                        variant="filled"
                                        >
                                    </v-textarea>

                                </v-col>

                                <v-col cols="12" md="2">

                                    <v-text-field
                                        v-model="modalRegistroChamado.data.tempoExecucao"
                                        label="Tempo Execução"
                                        placeholder="HHH:mm"
                                        variant="filled"
                                        maxlength="6"
                                    />
                                </v-col>

                                <v-col cols="12" sm="2">

                                    <v-text-field
                                        v-model="modalRegistroChamado.data.custoChamado"
                                        label="Custo Chamado"
                                        placeholder="R$ 0,00"
                                        type="text"
                                        variant="filled"
                                    />

                                </v-col>

                            </v-row>

                            <v-row dense>

                                <v-col cols="12" md="9">

                                    <!-- Campo para entrar com a descrição do orçamento -->
                                    <v-textarea
                                        v-model="modalRegistroChamado.data.descricaoOrcamento" 
                                        label="Descrição Orçamento"
                                        placeholder="Descreva o que será feito..."
                                        auto-grow
                                        rows="1"
                                        variant="filled"
                                        >
                                    </v-textarea>
                                    
                                </v-col>

                                <v-col cols="12" sm="3">

                                    <v-text-field
                                        v-model="modalRegistroChamado.data.custoOrcamento"
                                        label="Custo Orçamento"
                                        placeholder="R$ 0,00"
                                        type="text"
                                        variant="filled"
                                        @input="formatarCusto($event, 'orcamento')"
                                    />

                                </v-col>

                            </v-row>                            
                            
                            <v-row dense>

                                <v-col cols="12" md="3">

                                    <v-text-field
                                        :model-value="modalRegistroChamado.data.dataAbertura"
                                        label="Abertura"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                    ></v-text-field>
                                
                                </v-col>
                                
                                <v-col cols="12" md="3">

                                    <v-text-field
                                        :model-value="modalRegistroChamado.data.dataExecucao"
                                        label="Execução"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                    ></v-text-field>
                                
                                </v-col>    
                                
                                <v-col cols="12" md="3">

                                    <v-text-field
                                        :model-value="modalRegistroChamado.data.dataPendencia"
                                        label="Pendência"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                    ></v-text-field>
                                    
                                </v-col>
                                
                                <v-col cols="12" md="3">

                                     <v-text-field
                                        :model-value="modalRegistroChamado.data.dataConclusao"
                                        label="Concluído"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                    ></v-text-field>
                                    
                                </v-col>

                                
                            </v-row>                            

                            <v-row dense>

                                <v-col cols="12" md="12">

                                    <v-textarea
                                        v-model="modalRegistroChamado.data.tagChamado"
                                        label="Tag Chamado"
                                        auto-grow
                                        rows="1"
                                        variant="filled"
                                        >
                                    </v-textarea>

                                </v-col>

                                
                            </v-row>

                            <v-row dense>

                                <v-col cols="12">

                                    <v-textarea
                                        v-model="modalRegistroChamado.data.anexosChamado"
                                        label="Anexos Chamado"
                                        auto-grow
                                        rows="1"
                                        variant="filled"
                                        >
                                    </v-textarea>
                                    
                                </v-col>

                            </v-row>

                            <v-row dense>

                                <v-col cols="12">

                                    <v-textarea
                                        v-model="modalRegistroChamado.data.comentariosChamado"
                                        label="Comentários Chamado"
                                        auto-grow
                                        rows="1"
                                        variant="filled"
                                        >
                                    </v-textarea>
                                    
                                </v-col>

                            </v-row>

                        </v-form>

                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="red" class="mt-4" @click="fecharModalRegistroChamado">Fechar</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>

             <!-- Modal de exclusão -->
            <v-dialog v-model="modalExclusao.visible" max-width="500" persistent>

                <v-card>

                    <v-card-title class="d-flex align-center">
                        <v-icon icon="mdi-alert-circle" color="warning" class="mr-2" />
                        Excluir Chamado
                    </v-card-title>
                    
                    <v-card-text>
                        <p class="mb-2">
                            Tem certeza que deseja excluir o chamado 
                            <strong>{{ modalExclusao.data }}?</strong>
                        </p>
                        <p class="text-error">
                            <v-icon icon="mdi-alert" size="small" class="mr-1" />
                            Esta ação não pode ser desfeita.
                        </p>
                    </v-card-text>
                    
                    <v-card-actions>
                        <v-spacer />
                        <v-btn 
                            variant="outlined" 
                            @click="modalExclusao.visible = false"
                        >
                        Cancelar
                        </v-btn>
                        <v-btn 
                            color="error" 
                            @click="executarExclusao"
                            :loading="carregandoExclusao"
                        >
                            <v-icon icon="mdi-delete" left />
                            Excluir
                        </v-btn>
                    </v-card-actions>
                
                </v-card>

            </v-dialog>

            <!-- Modal de confirmação -->
            <ModalConfirmacao
                v-model="showModal"
                title="Confirma Remoção Anexo"
                :message="modalMessage"
                @confirm="executarRemocao"
                @cancel="cancelarRemocao"
            />

        </v-main>
  
    </v-app>

</template>

<script setup>

    // Importa dependências
    import { ref, watch, onMounted, onBeforeUnmount, reactive } from 'vue'

    import { useRoute, useRouter } from 'vue-router'
    
    // Importa axios para chamadas HTTP
    import axios from 'axios'

    // Importa o componente do editor de texto enriquecido
    import { QuillEditor } from '@vueup/vue-quill'
    
    // Importa o CSS do editor de texto enriquecido
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa o event bus
    import { emitter } from '../utils/eventBus'

    // Importa o componente do formulário de erros
    import { useErroStore } from '@/stores/erroStore'

    // Importa o componente do Snackbar
    import { useSnackbarStore } from '@/stores/snackbar'

    // Retorna um objeto com informações internas sobre o componente que está sendo executado no momento    
    import { getCurrentInstance } from 'vue'

    // Importa o componente do formulário de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa formulário de confirmação de operação
    import ModalConfirmacao from '@/components/ModalConfirmacao.vue'

    // Importa a store de chamados
    import { useChamadoStore } from '@/stores/chamadoStore'

    // importa rotina de limpeza de imagem do texto
    import { imagenUtils } from '@/utils/imagenUtils';

    // Importa o composable para upload de arquivos
    import { useUploadArquivos } from '@/composables/useUploadArquivos';

    // Desestrutura as funções do composable de upload de arquivos para facilitar o uso
    const { uploadArquivos, fazendoUpload } = useUploadArquivos();
    
    // Importa composable de download de arquivos
    import { useDownloadArquivo } from '@/composables/useDownloadArquivo';
    
    // Importa o composable
    const { downloadArquivo } = useDownloadArquivo();
    
    // Estados locais para controle individual
    const baixandoArquivoId = ref(null);
    const progressoDownloadLocal = ref(0);
    
    // Importa o composable para detectar o breakpoint atual
    const route = useRoute()

    // Importa o composable para detectar o breakpoint atual
    const router = useRouter()

    // Carrega o endereço das ap
    const API_BASE_URL = import.meta.env.VITE_API_URL;

    // Carrega o tempo de monitoramento de chamados
    const TEMPO_MONITORAMENTO = import.meta.env.VITE_TEMPO_MONITORAMENTO || 60000; // Padrão 2 minutos

    // Importa a store de erros
    const erroStore = useErroStore()

    // Permite acessar rotinas globais
    const { proxy } = getCurrentInstance()

    // Importa a store de chamados
    const loginStore = useLoginStore()

    // Importa a store de chamados
    const chamadoStore = useChamadoStore()

    // Variável que indica se o formulário modal de chamados está aberto
    var modalChamadoAberto = false;

    // Variável que salva o custo final de um chamado
    var custoCalculoChamado = 0;
    
    // Define variável usada para salvar o código do chamado quando este for salvo ou editado
    const mostraAcordeonComantarios = ref(0);

    // Importa a store do snackbar
    const snackbar = useSnackbarStore()
    
    // Busca dados do login do usuário
    const idColaborador = loginStore.idColaborador

    // Busca nome do colaborador que fez login
    const nomeColaborador = loginStore.nomeColaborador

    // Define o elemento v-text-field da pesquisa
    const textoBusca = ref('')

    // Define elemento da lista de chamados
    const listaChamados = ref([])
    
    // Define elemento que mostra a barra de progresso da carga da tabela
    const carregandoChamados = ref(false)

    // Total de itens da tabela
    const totalChamados = ref(0)

    // Inicializa contador de comentários
    const contadorComentarios = ref(0)

    // Define elemento que mostra a barra de progresso da carga dos comentários
    const carregandoComentariosAcordeon = ref(false)
    
    // Define as variáveis de paginação da tabela do acordeon de comentários do chamado
    const listaComentariosAcordeon = ref([])
    const totalComentariosAcordeon = ref(0)
    const acordeonComentarios = ref([])

    // Controla a visibilidade do modal
    const showModal = ref(false)       
    
    // Mensagem do modal
    const modalMessage = ref('')        

    // Dados pendentes para remoção
    const pendingData = ref({           
        index: null,
        arquivo: null,
        tipo: null
    })

    // Define array contendo o campo que deve ser ordenado inicialmente e a direção
    const opcoesTabelaChamados = ref({ 
        page: 1,
        itemsPerPage: 10,
        sortBy: ['status'],
        sortDesc: [false]
    })
    
    // Cria opções iniciais da tabela de comentários de chamados do modal
    const opcoesTabelaComentarios = ref({
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true]
    });

    // Seleciona o status default
    const statusSelecionados = ref(['ABERTO', 'EXECUCAO', 'PENDENTE', 'PENDENTE CLIENTE', 'ORCAMENTO','ORCAMENTO APROVADO', 'ATRASADO'])

    // Opções originais (sem contador no título)
    const opcoesStatus = ref([
        { title: 'Abertos', value: 'ABERTO' },
        { title: 'Execução', value: 'EXECUCAO' },
        { title: 'Pendentes', value: 'PENDENTE' },
        { title: 'Pendentes Clientes', value: 'PENDENTE CLIENTE' },
        { title: 'Orçamentos', value: 'ORCAMENTO' },
        { title: 'Orça. Aprovados', value: 'ORCAMENTO APROVADO' },
        { title: 'Orça. Rejeitados', value: 'ORCAMENTO REJEITADO' },
        { title: 'Concluídos', value: 'CONCLUIDO' },
        { title: 'Atrasados', value: 'ATRASADO' }
    ])

    // Objeto para armazenar contagens
    const contagemStatus = ref({})

    // Define as variáveis do timer que busca novos chamados
    let timerId = null
    
    // Define variável com a linha selecionada chamado
    const linhaSelecionada = ref([])
    const linhaComentarioSelecionada = ref(null)
    const linhaRegistroSelecionada = ref(null)
    
    // Define variável informando que os comentários estão sendo mostrados
    const comentariosExpandidos = ref([])
    
    // Define variável informando que os comentários estão sendo mostrados
    const registrosExpandidos = ref([])
    
    // Define os cabeçalhos da tabela de chamados
    const headersChamados = [
        { title: 'Funções', text: 'Funções', value: 'Funções', width: '1px', sortable: false },
        { title: 'Código', text: 'Código', value: 'idChamado', width: '1px', sortable: true },
        { title: 'Status', text: 'Status', value: 'Status', width: '40px', sortable: true },
        { title: 'Cliente', text: 'Cliente', value: 'Cliente', width: '380px', sortable: true },
        { title: 'Solicitante', text: 'Solicitante', value: 'Solicitante', width: '380px', sortable: true },
        { title: 'Prioridade', text: 'Prioridade', value: 'Prioridade', width: '10px', sortable: true },
        { title: 'Abertura', text: 'Abertura', value: 'Abertura', width: '280px', sortable: true },
        { title: 'Recursos', text: 'Recursos', value: 'Recursos', width: '280px', sortable: true },
        { title: 'Concluído', text: 'Concluído', value: 'Concluído', width: '280px', sortable: true },
        { title: 'Tag', text: 'Tag', value: 'Tag', width: '150px', sortable: true }
    ]

    // Define os cabeçalhos da tabela de comentários no acordeon
    const headersComentariosAcordeon = [
        { title: 'Funções', text: 'Funções', value: 'funcoes', width: '1px', sortable: false },
        { title: 'Código', text: 'Código', value: 'id', width: '1px', sortable: true },
        { title: 'Comentou', text: 'Comentou', value: 'nomeQuemComentou', width: '200px', sortable: true },
        { title: 'Lido Por', text: 'Lido Por', value: 'nomeQuemLeu', width: '200px', sortable: true },
        { title: 'Data Comentário', text: 'Data Comentário', value: 'dataComentario', width: '200px', sortable: true },
        { title: 'Lido', text: 'Lido', value: 'comentarioLido', width: '100px', sortable: true }
    ]

    // Desabilita campo cliente caso o chamado já exista
    const desabilitarCampoCliente = ref(false)
    
    // Desabilita o campo solicitação do modal de chamados
    const desabilitarCampoSolicitado = ref(false)
    
    // Desabilta o botão savar do modal de comentários
    const desabilitarSalvarModalComentarios = ref (false)
    
    // Define o array clientes do modal de chamados
    const clientes = ref([])
    
    // Define o array com as sugestões do autocompleta
    const sugestoes = ref([])
    
    // Adicione estas variáveis
    const indiceSelecionado = ref(-1)

    // Definindo os estados dos menus como reativos
    const vmodelCalendarioAberto = ref(false)
    const vmodelCalendarioPrevisao = ref(false)
    const vmodelCalendarioExecucao = ref(false)
    const vmodelCalendarioConclusao = ref(false)
    const vmodelCalendarioPendencia = ref(false)
    const vmodelCalendarioPrevisaoConclusao = ref(false)

    const mostrarRelogio = ref(false)

    // Variáveis da rotina de upload
    const uploadProgressChamado = ref(0);
    const uploadMessageChamado = ref('');
    
    const uploadProgressComentario = ref(0);
    const uploadMessageComentario = ref('');
    const isError = ref(false);
    
    // Declara que o componente pode emitir eventos, especificamente o evento update:modelValue.
    const emit = defineEmits(['submit']);
    
    const carregandoUsuarios = ref(false)

    // Variáveis usadas no upload de arquivos do chamado
    const mostraAnexosChamado = ref([]); // Arquivos mostrados no input do chamado
    const arquivosAnexadosChamado = ref([]); // Todos os arquivos (novos + existentes)
    const fazendoUploadChamado = ref(false);
    
    // Variáveis usadas no upload de arquivos do comentário
    const mostraAnexosComentario = ref([]); // Arquivos mostrados no input  do comentário
    const arquivosAnexadosComentario = ref([]); // Todos os arquivos (novos + existentes)
    const fazendoUploadComentario = ref(false);
        
    // Controle da mensagem
    const showMessageChamado = ref(false);
    const showMessageComentario = ref(false);
    const messageText = ref('');
    const messageType = ref('success');

    const textAreaNomeCliente = ref(null);
    const textAreaStatus = ref(null);
    const textAreaSolicitante = ref(null);
    const textAreaExecutado = ref(null);
    const textAreaPendente = ref(null);
    const textAreaOrcamento = ref(null);
    
    // ===== TOOLTIP COM DELAY E API =====
    // Usando objetos para armazenar o estado de cada tooltip
    const showTooltip = reactive({})
    const tooltipText = reactive({})
    let timeoutId = null
    let currentItemId = null

    // Variável que mostra o progresso da exclusão de um chamado
    const carregandoExclusao = ref(false)
    
    // Estado local para o modo da barra lateral
    const modoBarraLateral = ref(false)

    // Variáveis com dados de status do chamado e prioridade
    const dadosStatus = [
        { value: 'ABERTO', text: 'ABERTO' },
        { value: 'EXECUCAO', text: 'EXECUÇÃO' },
        { value: 'CONCLUIDO', text: 'CONCLUIDO' },
        { value: 'PENDENTE', text: 'PENDENTE' },
        { value: 'PENDENTE CLIENTE', text: 'PENDENTE CLIENTE' },
        { value: 'ATRASADO', text: 'ATRASADO' },
        { value: 'ORCAMENTO', text: 'ORÇAMENTO' },
        { value: 'ORCAMENTO APROVADO', text: 'ORÇAMENTO APROVADO' },
        { value: 'ORCAMENTO REJEITADO', text: 'ORÇAMENTO REJEITADO' }
    ]

    // Variável com dados de prioridade do chamado
    const dadosPrioridade = [
        { value: 'BAIXA', text: 'BAIXA' },
        { value: 'MÉDIA', text: 'MÉDIA' },
        { value: 'ALTA', text: 'ALTA' }
    ]
    
    // Constante do modal de chamado
    const modalDadosChamado = ref({
        visible: false,
        data: {
            idChamado: 0,
            Cliente: null,
            idEmpresa: null,
            idAbriuChamado: null,
            nomeColaboradorCliente: [],
            idProduto: [],
            produtos: [],
            idTipoChamado: [],
            tipoChamados: [],
            status: 'ABERTO',
            prioridade: 'BAIXA',
            idColaboradorSuporte: [],            
            nomeColaboradorSuporte: [],
            custoChamado: 'R$ 0,00',
            solicitado: null,
            executado: null,
            pendencia: null,
            dataAbertura: null,
            dataExecucao: null,
            dataConclusao: null,
            dataPendencia: null,
            dataPrevisaoPendencia: null,
            dataOrcamento: null,
            dataPrevisaoConclusao: null, 
            tempoExecucao: null,
            tagChamado: null,
            ordemExibicao: 0,
            descricaoOrcamento: null,
            horasDesenvolvimento: null,
            custoHora: 0,
            custoOrcamento: 'R$ 0,00',
            orcamentoLiberado: 0,
            chamadoNotificado: true,
            arquivosAnexosChamado: [],
            envioEmailCliente: true
        }
    });

    // Constantes do modal de registro chamado
    const modalRegistroChamado = ref({
        visible: false,
        data: {
            id: 0,
            nomeFantasia: '',
            nomeColaboradorCliente: '',
            nomeProduto: '',
            nomeTipoChamado: '',
            solicitado: '',
            executado: '',
            pendencia: '',
            status: '',
            colaboradoresSuporte: '',
            custoChamado: 'R$ 0,00',
            descricaoOrcamento: '',
            custoOrcamento: '',
            dataAbertura: '',
            dataExecucao: '',
            dataConclusao: '',
            dataPendencia: '',
            dataPrevisaoPendencia: '',
            dataPrevisaoConclusao: '',
            tempoExecucao: '',
            tagChamado: '',
            prioridade: '',
            anexosChamado: '',
            comentariosChamado: '',
            versaoChamado: ''
        }
    });
    
    // Variável reativa para o modal de comentários
    const modalDadosComentario = ref({
        visible: false,
        data: {
            id: 0,
            idChamado: 0,
            idComentou: 0,
            idQuemLeu: 0,
            textoComentario: '',
            dataComentario: '',
            nomeQuemComentou: '',
            nomeQuemLeu: '',
            comentarioLido: false,
            arquivosAnexosComentario: []
        }
    });

    // Estado do modal
    const modalExclusao = ref({
        visible: false,
        data: null
    })
    
    // Define o emit para o upload de arquivos
    const props = defineProps({
        modelValue: {
            type: Array,
            default: () => []
        },
        chamadoId: {
            type: [Number, String],
            required: false
        }
    });

    // Esta rotina filtra os caracteres digitados, permitindo apenas números
    const filtroNumerosDesenvolvimento = (event) => {

        const charCode = event.which ? event.which : event.keyCode
        if (charCode < 48 || charCode > 57) {            
            event.preventDefault()            
        }
    }
    
    const calcuolarCustoOrcamento = () => {

        const tempo = parseFloat(modalDadosChamado.value.data.horasDesenvolvimento)
        const custoHora = modalDadosChamado.value.data.custoHora
        
        if (!isNaN(tempo) && tempo > 0 && custoHora > 0) {
            modalDadosChamado.value.data.custoOrcamento = tempo * custoHora
        } else {
            modalDadosChamado.value.data.custoOrcamento = 0
        }

        modalDadosChamado.value.data.custoOrcamento = Number(modalDadosChamado.value.data.custoOrcamento).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    /* ROTINAS CONSTANTES DA PÁGINA DE CHAMADOS*/
    
    // Função principal
    const carregarTextoDoChamado = (item) => {

        const itemId = item.idChamado
        
        // Se já está mostrando o mesmo item, não faz nada
        if (showTooltip[itemId] && currentItemId === itemId) {
            return
        }
        
        // Fecha qualquer tooltip aberto
        Object.keys(showTooltip).forEach(key => {
            showTooltip[key] = false
        })
        
        // Reseta o texto para este item
        tooltipText[itemId] = 'Carregando...'
        currentItemId = itemId
        
        // Limpa timeout anterior
        if (timeoutId) clearTimeout(timeoutId)
        
        // Aguarda 600ms antes de chamar a API
        timeoutId = setTimeout(async () => {

            try {

                // Verifica se o mouse ainda está no mesmo item
                if (currentItemId !== itemId) return
                
                // Busca os dados do comentário
                const response = await axios.get(
                    `${API_BASE_URL}/operacao/buscaTextoSolicitacao/${itemId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${loginStore.token}`
                        }
                    }
                )
                
                const data = response.data
                
                // Verifica novamente após a resposta
                if (currentItemId !== itemId) return
                
                if (data.erro === false) {
                    tooltipText[itemId] = data.data || 'Texto não disponível'
                    showTooltip[itemId] = true
                } else {
                    tooltipText[itemId] = 'Não foi possível carregar'
                    showTooltip[itemId] = true
                }
            } catch (error) {
                console.error('Erro ao buscar texto:', error)
                tooltipText[itemId] = 'Erro ao carregar'
                showTooltip[itemId] = true
            }
        }, 600)
    }

    // Esta função fecha o tooltip do item específico, se estiver aberto
    const fecharTooltip = (itemId) => {

        // Fecha apenas o tooltip do item específico
        if (showTooltip[itemId] !== undefined) {
            showTooltip[itemId] = false
        }
        if (timeoutId) clearTimeout(timeoutId)
        currentItemId = null
    }

    // Formata o tamanho do arquivo
    const formatFileSize = (bytes) => {
        if (!bytes || isNaN(bytes)) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };
    
    // Função para atualizar o v-model com os arquivos atuais do chamado
    const manipuladorArquivoChamado = (event) => {

        // Verifica se o evento contém arquivos, sai da função se não houver
        const arquivoEntrada = event.target.files;

        // Verifica se o evento contém arquivos, sai da função se não houver
        if (!arquivoEntrada || arquivoEntrada.length === 0) return;

        // Verifica se já está fazendo upload de um arquivo, se sim, sai da função para evitar múltiplos uploads simultâneos
        if (fazendoUploadChamado.value === true) return;

        try{

            // Inicia o upload
            fazendoUploadChamado.value = true;
            
            // Reseta o progresso do upload para 0 a cada nova seleção de arquivos
            uploadProgressChamado.value = 0;

            // Converte lista de arquivos para array e filtra arquivos já selecionados
            const novoArquivo = Array.from(arquivoEntrada).filter(arquivo => {

                    // Verifica se o arquivo NÃO está já na lista arquivosAnexadosChamado
                    return !arquivosAnexadosChamado.value.some(
                        existingFile => 
                            existingFile.name === arquivo.name && 
                            existingFile.size === arquivo.size
                    );
                
            }).map(arquivo => ({
                    
                name: arquivo.name,
                size: arquivo.size,
                type: arquivo.type || 'application/octet-stream',
                lastModified: arquivo.lastModified || Date.now(),
                raw: arquivo,       // Mantém a referência ao File original
                uniqueId: null,     // Será preenchido após upload
                isExisting: false,
                displayName: `${arquivo.name} (${formatFileSize(arquivo.size)})`,
                serverName: null

            }));

            // Verifica se há novos arquivos para adicionar
            if (novoArquivo.length > 0) {

                // Salva o novo arquivo na lista de todos os anexos
                arquivosAnexadosChamado.value = [...arquivosAnexadosChamado.value, ...novoArquivo];
                
                // Atualiza o displayFiles para mostrar os novos arquivos
                snackbar.trigger(`${novoArquivo.length} Novo(s) Arquivo(s) Adicionado(s)`, 'success');

            } else {
                
                // Todos os arquivos selecionados já estão na lista
                snackbar.trigger('Arquivo Já Está Na Seleção', 'warning');
            }

            event.target.value = '';

        } catch (erro) {
            erroStore.exibirErro(erro);
        } finally {
            fazendoUploadChamado.value = false;
            uploadProgressChamado.value = 0;
        }
    };

    // Função para atualizar o v-model com os arquivos atuais do comentário
    const manipuladorArquivoComentario = (event) => {

        // Verifica se o evento contém arquivos, sai da função se não houver
        const arquivoEntrada = event.target.files;

        if (!arquivoEntrada || arquivoEntrada.length === 0) return;

        // Converte lista de arquivos para array e filtra arquivos já selecionados
        const novoArquivo = Array.from(arquivoEntrada).filter(arquivo => {

            // Verifica se o arquivo NÃO está já na lista arquivosAnexadosChamado
            return !arquivosAnexadosComentario.value.some(
                existingFile => 
                    existingFile.name === arquivo.name && 
                    existingFile.size === arquivo.size
            );
            
        }).map(arquivo => ({
                
            name: arquivo.name,
            size: arquivo.size,
            type: arquivo.type || 'application/octet-stream',
            lastModified: arquivo.lastModified || Date.now(),
            raw: arquivo,       // Mantém a referência ao File original
            uniqueId: null,     // Será preenchido após upload
            isExisting: false,
            displayName: `${arquivo.name} (${formatFileSize(arquivo.size)})`,
            serverName: null    // Será preenchido após upload

        }));

        // Atualiza a lista de arquivos mostrados
        if (novoArquivo.length > 0) {

            // Salva o novo arquivo na lista de todos os anexos
            arquivosAnexadosComentario.value = [...arquivosAnexadosComentario.value, ...novoArquivo];
            
            // Atualiza o displayFiles para mostrar os novos arquivos
            snackbar.trigger(`${novoArquivo.length} novo(s) arquivo(s) adicionado(s)`);

        } else {
            
            // Todos os arquivos selecionados já estão na lista
            snackbar.trigger('Arquivo Já Está Na Seleção', 'warning');
        }

        event.target.value = '';
    };

    // Executa download do arquivo anexo apontado pela variável fileObj, 
    // usando a função downloadArquivo do composable useDownloadArquivo
    const baixarAnexo = async (fileObj, tabela) => {

        // Verifica se este arquivo específico já está baixando
        if (baixandoArquivoId.value === fileObj.uniqueId) return;
        
        // Marca apenas este arquivo como baixando
        baixandoArquivoId.value = fileObj.uniqueId;
        progressoDownloadLocal.value = 0;
        
        try {
            await downloadArquivo(fileObj, tabela, {

                showProgress: true,
                onProgress: (percentual) => {
                    // Atualiza o progresso APENAS deste arquivo
                    progressoDownloadLocal.value = percentual;
                }
            });
            
        } finally {
            baixandoArquivoId.value = null;
            progressoDownloadLocal.value = 0;
        }
    };

    // Esta rotina abre o modal de confirmação
    const abreModalConfirmacao = (index, tipo) => {

        // Valida se o tipo é válido
        if (!tipo || (tipo !== 'chamado' && tipo !== 'comentario')) {
            console.error('Tipo inválido:', tipo)
            return
        }
        
        // Seleciona a lista correta baseado no tipo
        let listaArquivos

        // Verifica se foi chamado pelo icone da lista de anexos do chamado
        if (tipo === 'chamado') {

            // Se a lista de arquivos anexos do chamado não está definida sai da rotina
            if (!arquivosAnexadosChamado?.value) {
                return
            }

            // Salva a lista de anexos dos chamados
            listaArquivos = arquivosAnexadosChamado.value

        } else {
            
            // Se a lista de arquivos anexos do comentário não está definida sai da rotina
            if (!arquivosAnexadosComentario?.value) {
                return
            }

            // Salva a lista de anexos dos comentários
            listaArquivos = arquivosAnexadosComentario.value
        }
        
        // Valida se o índice existe
        if (index < 0 || index >= listaArquivos.length) {
            return
        }
        
        // Salva o arquivo selecionado
        const arquivo = listaArquivos[index]
        
        // Valida se o arquivo existe
        if (!arquivo) {
            return
        }
        
        // Define a mensagem baseada no tipo de arquivo
        const nomeArquivo = arquivo.name || 'Arquivo'
        
        modalMessage.value = arquivo.uniqueId 
            ? `Deseja Remover "${nomeArquivo}" do Servidor Permanentemente?`
            : `Deseja Remover "${nomeArquivo}" da Lista de Anexos?`
        
        // Guarda os dados pendentes
        pendingData.value = {
            index: index,
            arquivo: arquivo,
            tipo: tipo
        }
        
        // Abre o modal
        showModal.value = true
    }

    // Executa a remoção após confirmação
    const executarRemocao = async () => {

        if (pendingData.value.index !== null) {

            // Chama rotina de remoção passando o indice, arquivo e tipo
            await executaRemocaoAnexo(
                pendingData.value.index, 
                pendingData.value.arquivo, 
                pendingData.value.tipo
            )

            // Limpa os dados pendentes
            pendingData.value = {
                index: null,
                arquivo: null,
                tipo: null
            }
        }
    }

    // Trata botão de confirmação do cancelamento
    const cancelarRemocao = () => {
        
        pendingData.value = {
            index: null,
            arquivo: null,
            tipo: null
        }
    }

    // Função real de remoção
    const executaRemocaoAnexo = async (index, arquivo, tipo) => {

        // Define as configurações baseado no tipo
        const config = tipo === 'chamado' ? {

            listaArquivos: arquivosAnexadosChamado,
            tabelaApi: 'anexos_chamados',
            mostraAnexos: mostraAnexosChamado,
            nomeContexto: 'chamado',
            modalDados: modalDadosChamado

        } : {

            listaArquivos: arquivosAnexadosComentario,
            tabelaApi: 'anexos_comentarios',
            mostraAnexos: mostraAnexosComentario,
            nomeContexto: 'comentário',
            modalDados: modalDadosComentario // Comentário tem modal adicional
        }
        
        // Verifica se o índice ainda é válido
        if (index < 0 || index >= config.listaArquivos.value.length) return
        
        // Busca o arquivo atualizado na lista
        const arquivoParaRemover = config.listaArquivos.value[index]
        
        try {

            // Verifica se o arquivo já tem uniqueId (já salvo no servidor)
            if (arquivoParaRemover.uniqueId) {

                // Chama API para remover do servidor
                await axios.delete(
                    `${API_BASE_URL}/operacao/excluirArquivoAnexado/${arquivoParaRemover.uniqueId}/${config.tabelaApi}`,
                    {
                        headers: {
                            Authorization: `Bearer ${loginStore.token}`
                        }
                    }
                );
                
                // Verifica se está removendo imagem do chamado se não assume como do comentário
                if (tipo == 'chamado'){

                    // Busca texto do chamado
                    const textoChamado = modalDadosChamado.value.data.solicitado;

                    // Remove a imagem apontada por arquivoParaRemover.filePath do texto
                    const textoChamadoLimpo = imagenUtils.removeImagemTexto(textoChamado, arquivoParaRemover.filePath)

                    // Salva texto no editor sem a imagem
                    modalDadosChamado.value.data.solicitado = textoChamadoLimpo;

                } else {

                    // Busca texto do chamado
                    const textoComentario = modalDadosChamado.value.data.solicitado;

                    // Remove a imagem apontada por arquivoParaRemover.filePath do texto
                    const textoComentarioLimpo = imagenUtils.removeImagemTexto(textoComentario, arquivoParaRemover.filePath)

                    // Salva texto no editor sem a imagem
                    modalDadosChamado.value.data.comentario = textoComentarioLimpo;
                }
            }
            
            // Remove o arquivo da lista local
            config.listaArquivos.value.splice(index, 1)
            
            // Atualiza a lista de visualização se existir
            if (config.mostraAnexos.value && typeof config.mostraAnexos.value === 'object') {
                config.mostraAnexos.value = [...config.listaArquivos.value]
            }
            
            // Se for comentário e tiver modalDados, atualiza também
            if (tipo === 'comentario' && config.modalDados?.value?.data?.arquivosAnexosComentario) {
                config.modalDados.value.data.arquivosAnexosComentario.splice(index, 1)
            }
            
        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    }

    // Esta rotina trata o botão confirmar dos calendários
    const confirmaDatas = (funcao, dataEntrada, horaEntrada) => {

        if (!dataEntrada) return;

        if (!horaEntrada) {
            horaEntrada = '00:00';
        }   

        // Busca ano, mes e dia da data de abertura
        const ano = dataEntrada.getFullYear();
        const mes = dataEntrada.getMonth();
        const dia = dataEntrada.getDate();
        
        const [hora, minuto] = horaEntrada.split(':');

        const dataFinal = new Date(ano, mes, dia, hora, minuto);

        if (funcao == 1){            
            modalDadosChamado.value.data.dataAbertura = proxy.$formataDataBrasil(dataFinal)
        } else if (funcao == 2) {
            modalDadosChamado.value.data.dataPrevisaoPendencia = proxy.$formataDataBrasil(dataFinal)
        } else if (funcao == 3) {
            modalDadosChamado.value.data.dataExecucao = proxy.$formataDataBrasil(dataFinal)
        } else if (funcao == 4) {
            modalDadosChamado.value.data.dataConclusao = proxy.$formataDataBrasil(dataFinal)
        } else if (funcao == 5) {
            modalDadosChamado.value.data.dataPendencia = proxy.$formataDataBrasil(dataFinal)
        } else if (funcao == 6){
            modalDadosChamado.value.data.dataPrevisaoConclusao = proxy.$formataDataBrasil(dataFinal)
        }

        fecharCalendario();
    };

    // Função para fechar todos os menus do calendário
    const fecharCalendario = () => {

        vmodelCalendarioAberto.value = false;
        vmodelCalendarioPrevisao.value = false;
        vmodelCalendarioExecucao.value = false;
        vmodelCalendarioConclusao.value = false;
        vmodelCalendarioPendencia.value = false;
        vmodelCalendarioPrevisaoConclusao.value = false;
        mostrarRelogio.value = false;
    };

    // Esta função é chamada ao se digitar o custo de do chamado para formatar o valor em BR
    const formatarCusto = (event, campo) => {
        
        // Busca valor digitado
        const valorDigitado = event.target.value
        
        // Formata valor
        const valorFormatado = proxy.$formatarDinheiro(valorDigitado)

        // Salva valor formatado no campo custoChamado
        if (campo == 'chamado'){
            modalDadosChamado.value.data.custoChamado = valorFormatado
        } else {
            modalDadosChamado.value.data.custoOrcamento = valorFormatado
        }
    }
    
    // Carrega comentarios do chamado no acordeon do modal de cadastro de chamados
    const carregarListaComentariosAcordeon = async () => {
        
        // Blindagem contra estados intermediários
        const sortArray = Array.isArray(opcoesTabelaComentarios.value?.sortBy) 
            ? opcoesTabelaComentarios.value.sortBy 
            : []
        
        const primeiraOrdenacao = sortArray.length ? sortArray[0] : null

        // // 2) Defaults estáveis (sem jamais acessar [0] de algo indefinido)
        const ordenacaoPor = primeiraOrdenacao?.key ?? 'id'
        const direcaoOrdenacao = primeiraOrdenacao?.order ?? 'desc'
        
        // Extrai paginação
        const paginaAtual = opcoesTabelaComentarios.value.page ?? 1
        const itensPorPagina = opcoesTabelaComentarios.value.itemsPerPage ?? 10
        
        // Busca o idChamado do modalDadosChamado
        const idChamado = modalDadosChamado.value.data.idChamado

        // Limpa a lista de colaboradores
        listaComentariosAcordeon.value = []

        // Reseta o total de colaboradores
        totalComentariosAcordeon.value = 0

        try {

            // Verifica se não está executando a busca da lista de comentários
            if (carregandoComentariosAcordeon.value == false){

                // Liga o indicador de carregamento
                carregandoComentariosAcordeon.value = true
            
                // Chama a API para buscar os colaboradores da empresa
                const response = await axios.get(`${API_BASE_URL}/operacao/carregaListaComentariosChamado/${idChamado}`, {
                        params: { 
                            ordenacaoPor: ordenacaoPor,  
                            direcaoOrdenacao: direcaoOrdenacao || 'asc',
                            paginaAtual: paginaAtual,
                            itensPorPagina: itensPorPagina
                        },
                        headers: {
                            'Authorization': `Bearer ${loginStore.token}`
                        } 
                    }
                )

                // Mostra lista de comentários transformando a data em padrão brasileiro
                listaComentariosAcordeon.value = response.data.data.map(comentario => ({
                ...comentario,
                    dataComentario: proxy.$formataDataBrasil(comentario.dataComentario)
                }));

                // Atualiza os dados dos colaboradores e o total
                //listaComentariosAcordeon.value = response.data.data
                totalComentariosAcordeon.value = response.data.total
            }

        } catch (erro) {

            // Limpa indicação da carga da lista de comentários
            carregandoComentariosAcordeon.value = false
            
            // Usa a store de erros para exibir o erro
            erroStore.exibirErro(erro)

        } finally {

            // Limpa indicação da carga da lista de comentários
            carregandoComentariosAcordeon.value = false
        }
    }

    // Parar o timer de verificação de novos chamados
    const pararTimer = () => {

        // Verifica se existir um valor na variável timerId
        if (timerId) {
            
            // Limpa timer
            clearInterval(timerId)
            
            // Reseta variável contendo o timerId
            timerId = null            
        }
    }
    
    
    /* FUNÇÕES ASSINCRONAS  */

    // Função com Axios simplificada
    const buscaNovosChamados = async () => {

        try {

            // Se o campo de busca não tiver conteúdo realiza a busca de novos chamados
            if (textoBusca.value == null || textoBusca.value == ''){

                // Chama api passando os status selecionados no V-select e idEmpresa.
                // Caso seja uma empresa de manutenção passa idEmpresa = 0 para buscar novos chamados de todas empresas
                // e retorna se existem novos
                const response = await axios.get(`${API_BASE_URL}/operacao/buscaNovosChamados`,
                    {
                        params: {
                            filtroStatus: JSON.stringify(contagemStatus.value),
                            contadorComentarios: contadorComentarios.value,
                            idEmpresa: loginStore.idEmpresa,
                            idColaborador: loginStore.idColaborador,
                            empresaManutencao: loginStore.empresaManutencao                            
                        },
                        headers: {
                            'Authorization': `Bearer ${loginStore.token}`
                        } 
                    }
                )
                
                // Se hourevem novos chamados carrega a lista
                if (response.data.novosChamados == true){
                    carregaListaChamados()
                }
            }
            
        } catch (erro) {

            // Usa a store de erros para exibir o erro
            erroStore.exibirErro(erro)            
            
            // Para timer em caso de erro
            pararTimer()            
        }
    }

    // Esta função busca os chamados da API e atualiza a tabela
    async function carregaListaChamados() {

        // Blindagem contra chamadas simultâneas
        if (carregandoChamados.value) {
            console.log('Já está carregando, ignorando chamada');
            return;
        }

        // Fecha registros abertos ao carregar a lista de chamados
        fechaRegistrosChamado() 

        try {
        
            // Inicia a barra de carregamento
            carregandoChamados.value = true
            
            // Blindagem contra estados intermediários
            const sortArray = Array.isArray(opcoesTabelaChamados.value?.sortBy) 
                ? opcoesTabelaChamados.value.sortBy 
                : []
            
            const primeiraOrdenacao = sortArray.length ? sortArray[0] : null

            // // 2) Defaults estáveis (sem jamais acessar [0] de algo indefinido)
            const ordenacaoPor = primeiraOrdenacao?.key ?? 'status'
            const direcaoOrdenacao = primeiraOrdenacao?.order ?? 'asc'            
            
            // Montando o array de status para filtro
            const statusFiltro = [...statusSelecionados.value]

            // Fazendo a requisição para buscar os chamados
            const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaListaChamados`, {
                params: { 
                    filtroChamados: statusFiltro.join(','),
                    ordenacaoPor: ordenacaoPor,  
                    direcaoOrdenacao: direcaoOrdenacao,
                    idColaborador: idColaborador,
                    textoBusca: textoBusca.value,
                    emissoraTelevisao: loginStore.emissoraTelevisao
                },
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Verificando se a resposta contém dados
            const retorno = data.retornoApi || []

            // Se houver dados, formatar e atribuir aos headers e chamados
            if (retorno.length > 0) {
                
                // Carregando os dados na tabela
                listaChamados.value = retorno

                // Se houver comentarios no chamado atribui a propriedade existeComentario para piscar o número do chamado
                listaChamados.value = retorno.map(chamado => ({
                    ...chamado,
                    existeComentario: chamado.existeComentario ?? chamado.existeComanetario ?? 0,
                    escondeMenu: false
                }))

                // Conta comentários da lista de chamados
                contadorComentarios.value = listaChamados.value.filter(
                    chamado => chamado.existeComentario === 1
                ).length;

                // Mostra quantidade de chamados
                contarStatusDosChamados(retorno)

            } else {
                listaChamados.value = []
            }

            // Atualiza o total de chamados
            totalChamados.value = retorno.length

            // Marcar como concluído
            chamadoStore.recarregamentoConcluido()

            // Inicia timer de 1 minuto
            timerId = setInterval(buscaNovosChamados, TEMPO_MONITORAMENTO)                

        } catch (erro) {  
            
            // Em caso de erro desliga indicador de carregamento e mostra o erro
            erroStore.exibirErro(erro)      

        } finally {
            
            // Desliga o carregamento APÓS tudo terminar (sucesso ou erro)
            carregandoChamados.value = false
        }
    };

    // Esta função carrega os dados do comentário do chamado
    async function criarEditarComentario(item, idComentario = null, origem) {

        // Esconde todos os menus de função da lista se a origem não for modalChamados
        if (origem != 'modalChamados') item.escondeMenu = false;
            
        // Limpa os dados do comentário
        limpaDadosComentario();

        // Verifica se recebeu o código do comentário
        if (idComentario != null && idComentario != 0) {
        
            // Busca os dados do comentário
            const { data } = await axios.get(`${API_BASE_URL}/operacao/buscaComentario/${idComentario}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Verifica se a resposta contém dados
            const comentarioRecebido = data[0] || {};

            // Carrega os dados do comentário na modal
            Object.assign(modalDadosComentario.value.data, comentarioRecebido);
            
            // Formata a data do comentário para padrão brasileiro
            modalDadosComentario.value.data.dataComentario = proxy.$formataDataBrasil(modalDadosComentario.value.data.dataComentario)

            // Verifica se a resposta é um array indicando que existem arquivos anexados
            if (Array.isArray(comentarioRecebido.arquivosAnexosComentario)) {

                const arquivosExistentes = comentarioRecebido.arquivosAnexosComentario.map(arquivo => ({
                    filePath: arquivo.filePath,
                    filename: arquivo.filename,
                    originalName: arquivo.originalName,
                    size: arquivo.size,
                    serverName: arquivo.serverName,
                    uniqueId: arquivo.uniqueId,
                    isExisting: true,
                    displayName: `${arquivo.displayName || arquivo.originalName} (${(arquivo.size / 1024).toFixed(2)} KB)`,
                    raw: null
                }));
                
                // Atualiza a lista completa de arquivos anexados
                arquivosAnexadosComentario.value = [
                    ...arquivosExistentes, 
                    ...arquivosAnexadosComentario.value.filter(filtro => !filtro.isExisting)
                ];
                
                if (arquivosAnexadosComentario.value && arquivosAnexadosComentario.value.length > 0) {
                    mostraAnexosComentario.value = arquivosExistentes.map(arquivo => ({
                        name: arquivo.originalName,
                        size: arquivo.size,
                        type: 'application/octet-stream', // Tipo genérico para arquivos existentes
                        lastModified: Date.now()
                    }));
                }
            }

        } else {
            
            // Se a origem do chamado foi do modal de chamado busca o id do mesmo em modalDadosChamado.value.data.idChamado
            if (origem != 'modalChamados'){
                modalDadosComentario.value.data.idChamado = item.idChamado
            } else {
                modalDadosComentario.value.data.idChamado = modalDadosChamado.value.data.idChamado
            }

            // Atribui o id do colaborador que está comentando
            modalDadosComentario.value.data.idComentou = idColaborador
        }

        // Torna modal comentários visível
        modalDadosComentario.value.visible = true
    };

    // Esta rotina mostra o registro do chamado selecionado
    async function lerRegistroChamado(item, idRegistroChamado = null, origem){

        try{

            // Busca registro de operações
            const { data } = await axios.get(`${API_BASE_URL}/operacao/buscaRegistroChamado/${idRegistroChamado}` , {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Salva os dados no modal
            modalRegistroChamado.value.data = data[0]

            // Converte as datas para formato brasileiro
            modalRegistroChamado.value.data.dataAbertura = proxy.$formataDataBrasil(modalRegistroChamado.value.data.dataAbertura)
            modalRegistroChamado.value.data.dataExecucao = proxy.$formataDataBrasil(modalRegistroChamado.value.data.dataExecucao)
            modalRegistroChamado.value.data.dataConclusao = proxy.$formataDataBrasil(modalRegistroChamado.value.data.dataConclusao)
            modalRegistroChamado.value.data.dataPendencia = proxy.$formataDataBrasil(modalRegistroChamado.value.data.dataPendencia)
            modalRegistroChamado.value.data.dataPrevisaoPendencia = proxy.$formataDataBrasil(modalRegistroChamado.value.data.dataPrevisaoPendencia)

            // Formata custo do chamado
            modalRegistroChamado.value.data.custoChamado = Number(modalRegistroChamado.value.data.custoChamado).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            
            // Formata o custo do orçamento
            modalRegistroChamado.value.data.custoOrcamento = Number(modalRegistroChamado.value.data.custoOrcamento).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            // Exibe o formulário modal
            modalRegistroChamado.value.visible = true

        } catch(erro){
            erroStore.exibirErro(erro)
        }
    }    
    
    // Função para salvar o comentário do chamado
    async function salvaComentario() {
        
        // Busca texto comentário e limpa eventuais comandos html
        let textoComentario = limpaTextoHtml(modalDadosComentario.value.data.textoComentario.trim())
        
        // Verifica se houve preenchimento do texto
        if (textoComentario == ''){            
            erroStore.exibirErro('Não Foi Digitado Nenhum Comentário') 
            return
        }

        try{

            // Executa upload dos arquivos anexados e obtém os dados dos arquivos salvos no servidor
            const resultadoUpload = await uploadArquivos(arquivosAnexadosComentario, {

                token: loginStore.token,
                onProgress: (progresso) => {
                    
                    // Atualiza o progresso para mostrar no v-progress-linear
                    uploadProgressComentario.value = progresso.percentual;
                }
            });
            
            // Se upload não retornou erro, salva os dados dos arquivos anexados
            if (resultadoUpload.status != 'erro') {

                // Extrai apenas os dados necessários
                const dadosAnexos = arquivosAnexadosComentario.value.map(arquivo => ({
                    filePath: arquivo.filePath,
                    filename: arquivo.filename,
                    originalName: arquivo.originalName,
                    size: arquivo.size,
                    serverName: arquivo.serverName,
                    uniqueId: arquivo.uniqueId  
                }));

                // Salva os dados dos arquivos anexados
                modalDadosComentario.value.data.arquivosAnexosComentario = dadosAnexos;
            } else {
                modalDadosComentario.value.data.arquivosAnexosComentario = [];
            }
            
            // Atualiza o id e nome de quem comentou
            if (modalDadosComentario.value.data.comentarioLido == true) {

                modalDadosComentario.value.data.idQuemLeu = idColaborador
                modalDadosComentario.value.data.nomeQuemLeu = nomeColaborador

            } else {

                modalDadosComentario.value.data.idQuemLeu = 0
                modalDadosComentario.value.data.nomeQuemLeu = ''
            }

            // Busca o id do chamado
            const idChamado = modalDadosComentario.value.data.idChamado;

            // Busca o id do comentário
            const idComentario = modalDadosComentario.value.data.id

            // Converte boolean para 0 ou 1
            modalDadosComentario.value.data.comentarioLido = modalDadosComentario.value.data.comentarioLido ? 1 : 0
    
            // Chama a API para salvar o comentário
            await axios.post(`${API_BASE_URL}/operacao/salvaComentario/${idComentario}`, modalDadosComentario.value.data , {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            snackbar.trigger('Comentário Salvo Com Sucesso', 'success')

            // Verifica se o modal de chamados está aberto
            if (modalDadosChamado.value.visible == true){

                // Carrega lista comentários do acordeon
                carregarListaComentariosAcordeon();

            } else {

                // Verifica se o chamado já está expandido
                const estadoListaComentarios = comentariosExpandidos.value.indexOf(idChamado)

                // Se já estiver expandido e não for para atualizar comentário, recolhe
                if (estadoListaComentarios !== -1) {
                    comentariosExpandidos.value.splice(estadoListaComentarios, 1)
                }                
            }
            
            // Recarrega a lista de chamados
            carregaListaChamados();

        } catch(erro){            
            erroStore.exibirErro(erro)
        }
    };

    // Esta função carrega os comentários ou limpa a tabela caso não haja dados
    async function listaComentariosChamado(item, atualizaComentario = false) {

        // Inicializa idChamado
        var idChamado = 0;

        // Verifica se é para atualizar comentário ou expandir/recolher
        if (atualizaComentario == false) {

            // Busca o idChamado do item
            idChamado = item.idChamado || item.idchamado || 0;

            // Esconde todos os menus de função da lista
            item.escondeMenu = false;
        
        } else{
            
            // Se for para atualizar comentário, usa o item como idChamado diretamente
            idChamado = item
        }

        // Verifica se o chamado já está expandido
        const estadoListaComentarios = comentariosExpandidos.value.indexOf(idChamado)

        // Se já estiver expandido e não for para atualizar comentário, recolhe
        if (estadoListaComentarios !== -1 && !atualizaComentario) {

            // Já está expandido → recolhe
            comentariosExpandidos.value.splice(estadoListaComentarios, 1)

        } else {

            try{

                // Expande e carrega comentários
                comentariosExpandidos.value.push(idChamado)

                // Busca a linha do chamado na lista
                const linhaListaChamados = listaChamados.value.find(buscaId => buscaId.idChamado === idChamado)

                // Blindagem contra estados intermediários
                const sortArray = Array.isArray(opcoesTabelaComentarios.value?.sortBy) 
                    ? opcoesTabelaComentarios.value.sortBy 
                    : []
                
                const primeiraOrdenacao = sortArray.length ? sortArray[0] : null

                // // 2) Defaults estáveis (sem jamais acessar [0] de algo indefinido)
                const ordenacaoPor = primeiraOrdenacao?.key ?? 'id'
                const direcaoOrdenacao = primeiraOrdenacao?.order ?? 'desc'
                
                // Extrai paginação
                const paginaAtual = opcoesTabelaComentarios.value.page ?? 1
                const itensPorPagina = opcoesTabelaComentarios.value.itemsPerPage ?? -1

                // Busca os comentários do chamado
                const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaListaComentariosChamado/${idChamado}`, {
                    params: { 
                        ordenacaoPor: ordenacaoPor,  
                        direcaoOrdenacao: direcaoOrdenacao || 'asc',
                        paginaAtual: paginaAtual,
                        itensPorPagina: itensPorPagina
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    } 
                })

                // Garante que mesmo sem dados retorne um array
                const retorno = data.data || []

                // Sanitiza cada comentário para ficar em uma única linha
                linhaListaChamados.Comentarios = (retorno || []).map(c => ({
                    ...c, 
                    comentario: c.textoComentario
                    // substitui </p><p> por espaço
                    .replace(/<\/p>\s*<p>/gi, ' ')
                    // remove tags de parágrafo
                    .replace(/<p>|<\/p>/gi, '')
                    // remove quebras de linha via <br>
                    .replace(/<br\s*\/?>/gi, ' ')
                    // compacta múltiplos espaços em apenas um
                    .replace(/\s+/g, ' ')
                    .trim(),
                    dataComentario: proxy.$formataDataBrasil(c.dataComentario) || '',

                }))

            }catch (erro) {
                erroStore.exibirErro(erro)
            }
        }
    };
    
    // Esta função carrega os comentários ou limpa a tabela caso não haja dados
    async function listaRegistrosChamado(item) {

        // Esconde todos os menus de função da lista
        item.escondeMenu = false;
        
        // Busca idChamado do item
        var idChamado = item.idChamado

        // Limpa a lista de registros
        registrosExpandidos.value = []
            
        try{

            // Expande e carrega comentários
            registrosExpandidos.value.push(idChamado)

            // Busca a linha do chamado na lista
            const linhaListaRegistros = listaChamados.value.find(buscaId => buscaId.idChamado === idChamado)

            // Busca os comentários do chamado
            const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaListaRegistrosChamado/${idChamado}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Garante que mesmo sem dados retorne um array
            const retorno = data.data || []

            // Carrega os registros na linha do chamado
            linhaListaRegistros.Registros = retorno

        }catch (erro) {
            erroStore.exibirErro(erro)       
        }
    };

    // Fecha tabela de registros do equipamento
    function fechaRegistrosChamado() {

        // Remove o id do chamado da lista de registros expandidos para fechar a seção de registros
        registrosExpandidos.value = []
    }

    // Esta função carrega os produtos e tipos de chamado ativos
    async function carregaTiposChamado(){
            
        try {

            // Verifica se a empresa que usuário fez login é emissora de televisão
            if (loginStore.emissoraTelevisao === 1){

                // Carrega lista de avarias
                var { data: dataTiposChamados  } = await axios.get(`${API_BASE_URL}/administracao/carregaListaAvarias`, {
                    params: {
                        ordenacaoPor: 'nome',
                        direcaoOrdenacao: 'asc'
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Garante que temos um array válido de tipos de chamados
                const tipoChamados = Array.isArray(dataTiposChamados.data) 
                    ? dataTiposChamados.data 
                    : dataTiposChamados.data || []
                
                // Filtra tipos de chamados ativos
                const tiposChamadosAtivos = tipoChamados.filter(tipoChamado => tipoChamado.ativo == 1)

                // Carrega os tipos de chamados no formato que o v-select precisa
                modalDadosChamado.value.data.tipoChamados = tiposChamadosAtivos.map(tipo => ({
                    value: tipo.idAvaria,
                    title: tipo.nome
                })) 

            } else {
            
                // Busca todos os tipos de chamados
                var { data: dataTiposChamados } = await axios.get(`${API_BASE_URL}/administracao/carregaListaTiposChamado`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                });

                // Garante que temos um array válido de tipos de chamados
                const tipoChamados = Array.isArray(dataTiposChamados.data) 
                    ? dataTiposChamados.data 
                    : dataTiposChamados.data || []
                
                // Filtra tipos de chamados ativos
                const tiposChamadosAtivos = tipoChamados.filter(tipoChamado => tipoChamado.ativo == 1)

                // Carrega os tipos de chamados no formato que o v-select precisa
                modalDadosChamado.value.data.tipoChamados = tiposChamadosAtivos.map(tipo => ({
                    value: tipo.idTipoChamado,
                    title: tipo.nome
                })) 
            }           
        
        } catch(erro){
            throw "Erro Carregar Produto Ou Chamado."
        }            
    }

    // Carrega colaborador que abriu o chamado
    async function carregaColaboradorAbriuChamado(idChamado){

        try{

            // Busca todos colaboradores do cliente (solicitantes)
            const { data: dataColaborador } = await axios.get(`${API_BASE_URL}/operacao/buscaColaboradoresChamado/${idChamado}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            const colaboradores = Array.isArray(dataColaborador) 
                ? dataColaborador 
                : dataApi.dataColaborador || []
            
            // Carrega todos colaboradores cadastrados no chamado
            modalDadosChamado.value.data.nomeColaboradorCliente = colaboradores.map(colaborador => ({
                value: colaborador.id, 
                title: colaborador.nome
            }))
            
        } catch(erro){
            throw "Erro Carregar Colaborador Abriu Chamado."
        }
    }

    // Carrega produtos cadastrados na empresa
    async function carregaProdutosEmpresa(idEmpresa, idProduto){

        try {

            // Carrega os produtos cadastrados na empresa
            const { data: dataProdutos } = await axios.get(`${API_BASE_URL}/operacao/buscaProdutosEmpresa/${idEmpresa}/${loginStore.emissoraTelevisao}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Verifica se o produto do chamado existe na lista da empresa
            const produtoExistente = dataProdutos.data.find(
                produto => produto.idProduto === idProduto
            );

            // Se o produto do chamado existir na lista da empresa, carrega apenas os produtos da empresa    
            if (produtoExistente) {

                // Carrega os produtos ATIVOS no formato que o v-select precisa
                modalDadosChamado.value.data.produtos = dataProdutos.data.map(produto => ({
                    value: produto.idProduto,
                    title: produto.nome
                }))

            } else {
            
                // Se o produto do chamado não existir na lista da empresa, carrega todos os produtos
                const { data: dataProdutos } = await axios.get(`${API_BASE_URL}/administracao/carregaListaProdutos`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                });

                // Garante que temos um array válido de produtos
                const arrayProdutos = Array.isArray(dataProdutos.data) 
                    ? dataProdutos.data 
                    : dataProdutos.data || []

                // Carrega os produtos ATIVOS no formato que o v-select precisa
                modalDadosChamado.value.data.produtos = arrayProdutos.map(produto => ({
                    value: produto.idProduto,
                    title: produto.nome
                }))
            }            

        } catch(erro){
            throw "Erro Carregar Produtos Empresa."
        }
    }

    // Carrega colaboradores empresa manutenção
    async function carregaListaTecnicos(){

        try{

            // Carrega colaboradores da empresa de manutenção
            const { data: dataUsuarios } = await axios.get(`${API_BASE_URL}/administracao/carregaListaTecnicos/${loginStore.idEmpresa}/${loginStore.emissoraTelevisao}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Garante que temos um array válido de colaboradores da empresa de manutenção
            const usuariosArr = Array.isArray(dataUsuarios.data) 
                ? dataUsuarios.data 
                : dataUsuarios.data || []
            
            // Filtra colaboradores ativos
            const recursosAtivos = usuariosArr.filter(recurso => recurso.ativo == 1)

            // Transforma o array dos colaboradores no formato que o v-select precisa
            modalDadosChamado.value.data.nomeColaboradorSuporte = recursosAtivos.map(recurso => ({
                value: recurso.id,
                title: recurso.nome,
                valorHora: recurso.valorHora
            }))

            return recursosAtivos

        } catch(erro){
            throw "Erro Carregar Recursos Empresa Manutenção."
        }
    }

    // Função para abrir o modal para criar novo chamado
    async function novoChamado(){

        // Limpa dados do formulário
        limpaDadosChamado()
        
        // Desabilita o campo Cliente se o chamado já existir
        desabilitarCampoCliente.value = false;

        try{
        
            // Carrega produtos e tipos de chamados
            carregaTiposChamado()

            // Carrega colaboradores da empresa que fez login
            const { data: dataUsuarios } = await axios.get(`${API_BASE_URL}/administracao/carregaListaTecnicos/${loginStore.idEmpresa}/${loginStore.emissoraTelevisao}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Garante que temos um array válido de recursos (colaboradores da empresa apontada por loginStore.idEmpresa)
            const recursos = Array.isArray(dataUsuarios.data) 
                ? dataUsuarios.data 
                : dataUsuarios.data || []
            
            // Filtra colaboradores ativos
            const recursosAtivos = recursos.filter(recurso => recurso.ativo == 1)
            
                // Transforma os usuários no formato que o v-select precisa
            modalDadosChamado.value.data.nomeColaboradorSuporte = recursosAtivos.map(recurso => ({
                value: recurso.id,
                title: recurso.nome,
                valorHora: recurso.valorHora
            }))

            // Exibe o modal com os dados do chamado
            modalDadosChamado.value.visible = true

            // Tenta focar sempre que o componente é atualizado e o status é CONCLUIDO
            setTimeout(() => {                    
                textAreaNomeCliente.value?.focus?.();
            }, 100);

        }catch (erro) {
            erroStore.exibirErro(erro)
        }   
    };

    // Função para buscar dados de um chamado específico
    async function editaChamado(item, acaoStatus) {

        try {

            // Busca o idChamado do item, considerando possíveis variações de nome
            const idChamado = item.idChamado || item.idchamado || 0;

            // Esconde todos os menus de função da lista
            item.escondeMenu = false;

            // Limpa dados do formulário        
            limpaDadosChamado()

            // Busca os dados do chamado específico por idChamado
            const { data: dataChamado } = await axios.get(`${API_BASE_URL}/operacao/buscaDadosChamadoId/${idChamado}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });
            const retornoChamado = dataChamado[0] || {}
            
            if (!retornoChamado) {
                erroStore.exibirErro('Chamado Não Encontrado')
                return
            }
            
            // Salva código do cliente
            modalDadosChamado.value.data.idChamado = idChamado

            // Muda estado da variável reativa para que o acordeon de comentários seja mostrado
            mostraAcordeonComantarios.value = idChamado

            // Salva id e nome da empresa da empresa
            modalDadosChamado.value.data.idEmpresa = retornoChamado.idEmpresa
            modalDadosChamado.value.data.Cliente = retornoChamado.Cliente;
            
            // Carrega colaborador que abriu o chamado
            // Aponta para o colaborador que abriu o chamado
            carregaColaboradorAbriuChamado(idChamado)            
            modalDadosChamado.value.data.idAbriuChamado = retornoChamado.idAbriuChamado

            // Carrega produtos da empresa e aponta para o produto referente ao chamado
            carregaProdutosEmpresa(retornoChamado.idEmpresa, retornoChamado.idProduto)            
            modalDadosChamado.value.data.idProduto = retornoChamado.idProduto
            
            // Carrega tipos de chamados ativos e aponta para o que foi aberto
            carregaTiposChamado()
            modalDadosChamado.value.data.idTipoChamado = retornoChamado.idTipoChamado

            // Mostra o que foi solicitado
            modalDadosChamado.value.data.solicitado = retornoChamado.solicitado
            
            // Atualiza a prioridade
            const prioridadeValida = dadosPrioridade.some(item => item.value === retornoChamado.prioridade)
            modalDadosChamado.value.data.prioridade = prioridadeValida ? retornoChamado.prioridade : 'BAIXA'
            
            // Mostra o status do chamado ou 'ABERTO' caso vier null
            modalDadosChamado.value.data.status = retornoChamado.status !== null ? retornoChamado.status : 'ABERTO';

            // Carrega recursos da empresa de manutenção
            const recursosAtivos = await carregaListaTecnicos()

            // Extrai os nomes dos recursos do chamado e transforma em um array
            const nomesRecursos = (retornoChamado.recursos || '')
                .split(',')
                .map(n => n.trim().toUpperCase())
                .filter(Boolean)

            // Filtra os usuários que correspondem aos nomes dos recursos
            // e extrai os IDs dos usuários selecionados
            const selectedUserIds = modalDadosChamado.value.data.nomeColaboradorSuporte
                .filter(recursosAtivos => nomesRecursos.includes(recursosAtivos.title.toUpperCase()))
                .map(recursosAtivos => recursosAtivos.value)
            
            // Seleciona os recuros usados no chamado
            modalDadosChamado.value.data.idColaboradorSuporte = selectedUserIds

            // Mostra a pendencia e o tempo previsto para solução
            modalDadosChamado.value.data.pendencia = retornoChamado.pendencia
            modalDadosChamado.value.data.dataPrevisaoPendencia = proxy.$formataDataBrasil(retornoChamado.dataPrevisaoPendencia);  
            
            // Mostra o que foi executado, o tempo de execução e o custo do chamado
            modalDadosChamado.value.data.executado = retornoChamado.executado
            modalDadosChamado.value.data.tempoExecucao = retornoChamado.tempoExecucao
            modalDadosChamado.value.data.custoChamado = Number(retornoChamado.custoChamado).toLocaleString('pt-BR', {
                style: 'currency',           
                currency: 'BRL',             
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            // Mostra o tempo de desenvolvimento do orchamento, caso exista, ou 0 caso não exista
            modalDadosChamado.value.data.horasDesenvolvimento = retornoChamado.horasDesenvolvimento

            // Mostra descrição do orcamento e custo
            modalDadosChamado.value.data.descricaoOrcamento = retornoChamado.descricaoOrcamento
            modalDadosChamado.value.data.custoOrcamento = Number(retornoChamado.custoOrcamento).toLocaleString('pt-BR', {
                style: 'currency',           // ← Isso adiciona o símbolo da moeda
                currency: 'BRL',             // ← Define a moeda como Real Brasileiro
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            
            // Mostra data de abertura
            modalDadosChamado.value.data.dataAbertura = proxy.$formataDataBrasil(retornoChamado.dataAbertura)
            
            // Mostra data de execução
            modalDadosChamado.value.data.dataExecucao = proxy.$formataDataBrasil(retornoChamado.dataExecucao);
            
            // Mostra data de pendência
            modalDadosChamado.value.data.dataPendencia = proxy.$formataDataBrasil(retornoChamado.dataPendencia);

            // Mostra data de conclusão
            modalDadosChamado.value.data.dataConclusao = proxy.$formataDataBrasil(retornoChamado.dataConclusao);
            
            // Mostra data de previsão de conclusão
            modalDadosChamado.value.data.dataPrevisaoConclusao = proxy.$formataDataBrasil(retornoChamado.dataPrevisaoConclusao);
            
            // Mostra a tag do chamado
            modalDadosChamado.value.data.tagChamado = retornoChamado.tagChamado
            
            // Carrega o custo de desenvolvimento para a empresa do chamado
            modalDadosChamado.value.data.custoHora = retornoChamado.custoHora

            // Verifica se a resposta é um array indicando que existem arquivos anexados
            if (Array.isArray(retornoChamado.arquivosAnexosChamado)) {

                // Mapeia os arquivos existentes
                const arquivosExistentes = retornoChamado.arquivosAnexosChamado.map(arquivo => ({
                    filePath: arquivo.filePath,
                    filename: arquivo.filename,
                    originalName: arquivo.originalName,
                    size: arquivo.size,
                    serverName: arquivo.serverName,
                    uniqueId: arquivo.uniqueId,
                    isExisting: true,
                    displayName: arquivo.displayName,
                    raw: null
                }));
                
                // Atualiza a lista completa de arquivos anexados
                arquivosAnexadosChamado.value = [
                    ...arquivosExistentes, 
                    ...arquivosAnexadosChamado.value.filter(filtro => !filtro.isExisting)
                ];
                
                // Adicionado .value e nome da variável corrigido
                if (arquivosAnexadosChamado.value && arquivosAnexadosChamado.value.length > 0) {
                    mostraAnexosChamado.value = arquivosAnexadosChamado.value.map(arquivo => ({
                        name: arquivo.originalName,
                        size: arquivo.size,
                        type: 'application/octet-stream',
                        lastModified: Date.now()
                    }));
                }

                // Salva dados da imagem no modal
                modalDadosChamado.value.data.arquivosAnexosChamado = mostraAnexosChamado.value;
            }

            // Desabilita o campo Cliente se o chamado já existir
            desabilitarCampoCliente.value = true;

            // Desabilita o campo solicitado se o chamado já existir
            desabilitarCampoSolicitado.value = true;
            
            // Busca a data e hora atual
            const dataHoraAtual = new Date();
            
            // Verifica se existe ação determinada pela lista de funções
            if (acaoStatus == 1) {
                
                modalDadosChamado.value.data.dataExecucao =  proxy.$formataDataBrasil(dataHoraAtual);
                modalDadosChamado.value.data.status = 'EXECUÇÃO'

            // Verifica se a ação refere-se à pendencia do chamado
            } else if (acaoStatus == 2) {

                modalDadosChamado.value.data.dataPendencia = proxy.$formataDataBrasil(dataHoraAtual);
                modalDadosChamado.value.data.status = 'PENDENTE'

            // Verifica se a ação refere-se à pendencia com cliente
            } else if (acaoStatus == 3) {

                modalDadosChamado.value.data.dataPendencia = proxy.$formataDataBrasil(dataHoraAtual);
                modalDadosChamado.value.data.status = 'PENDENTE CLIENTE'

            // Verifica se a ação refere-se ao orçamento do chamado
            } else if (acaoStatus == 4) {

                modalDadosChamado.value.data.status = 'ORÇAMENTO'   

            // Verifica se a ação refere-se à liberação do orçamento
            } else if (acaoStatus == 5) {

                modalDadosChamado.value.data.status = 'LIBERAR ORÇAMENTO'

            // Verifica se a ação refere-se à aprovação do orçamento
            } else if (acaoStatus == 6) {

                modalDadosChamado.value.data.status = 'ORÇAMENTO APROVADO'

            // Verifica se a ação refere-se à rejeição do orçamento
            } else if (acaoStatus == 7) {

                modalDadosChamado.value.data.status = 'ORÇAMENTO REJEITADO'
            }

            // Exibe o modal com os dados do chamado
            modalDadosChamado.value.visible = true

            // Tenta focar sempre que o componente é atualizado e o status é CONCLUIDO
            setTimeout(() => {                    
                textAreaStatus.value?.focus?.();
            }, 100);

        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    };

    // Esta função cria um novo chamado ou edita um chamado existente
    async function salvaChamado(funcaoRetorno) {
        
        try {

            // Verifica se foi selecionado o cliente
            if (!modalDadosChamado.value.data.Cliente || modalDadosChamado.value.data.Cliente == ''){                
                erroStore.exibirErro('Selecione Um Cliente')
                return
            }

            // Verifica se foi selecionado o solicitante
            if (!modalDadosChamado.value.data.idAbriuChamado || modalDadosChamado.value.data.idAbriuChamado == ''){  
                erroStore.exibirErro('Selecione Solicitante')
                return
            }

            // Verifica se foi selecionado o produto
            if (!modalDadosChamado.value.data.idProduto || modalDadosChamado.value.data.idProduto == ''){                
                erroStore.exibirErro('Selecione Produto Origem do Chamado')
                return
            }

            // Verifica se foi selecionado o tipo de chamado
            if (!modalDadosChamado.value.data.idTipoChamado || modalDadosChamado.value.data.idTipoChamado == ''){                
                erroStore.exibirErro('Selecione Tipo de Chamado')
                return
            }

            // Verifica se foi selecionado o status do chamado
            if (!modalDadosChamado.value.data.status || modalDadosChamado.value.data.status == ''){                

                erroStore.exibirErro('Selecione Status do Chamado')
                return

            } else {

                // Verifica se o status é aberto
                if (modalDadosChamado.value.data.status == 'ABERTO') {

                    // Se data de abertura estiver vazia, busca a data atual do servidor
                    if (modalDadosChamado.value.data.dataAbertura == ''){
                        
                        // Cria data atual em formato ISO 8601
                        const dataAtual = new Date().toISOString();

                        // Busca hora atual do servidor e salva como data e hora da abertura do chamado
                        modalDadosChamado.value.data.dataAbertura = proxy.$formataDataBrasil(dataAtual);                        
                    }

                // Verifica se o status é execução
                } else if (modalDadosChamado.value.data.status == 'EXECUCAO') {

                    // Verifica se data de execução foi preenchida
                    if (!modalDadosChamado.value.data.dataExecucao || modalDadosChamado.value.data.dataExecucao == ''){
                        erroStore.exibirErro('Selecione Data de Início da Execução')
                        return
                    }

                    // Verifica se foi selecionado ao menos um recurso para executar o chamado
                    if (modalDadosChamado.value.data.idColaboradorSuporte.length == 0){
                        erroStore.exibirErro('Selecione Um Ou Mais Recursos para Executar Chamado')
                        return
                    }

                // Verifica se o status é pendente ou pendente com cliente
                } else if (modalDadosChamado.value.data.status == 'PENDENTE' ||
                           modalDadosChamado.value.data.status == 'PENDENTE CLIENTE') {

                    // Verifica se data de pendência foi preenchida
                    if (!modalDadosChamado.value.data.dataPendencia || modalDadosChamado.value.data.dataPendencia == ''){
                        erroStore.exibirErro('Selecione Data de Pendência')
                        return
                    }

                    // Verifica se foi digitado o motivo da pendência
                    if (!modalDadosChamado.value.data.pendencia || modalDadosChamado.value.data.pendencia == ''){
                        erroStore.exibirErro('Descreva o Motivo da Pendência')
                        return
                    }

                    // Verifica se o status é pendente para solicitar data de previsão
                    if (modalDadosChamado.value.data.status == 'PENDENTE'){

                        if (!modalDadosChamado.value.data.dataPrevisaoPendencia || modalDadosChamado.value.data.dataPrevisaoPendencia == ''){
                            erroStore.exibirErro('Selecione Data de Previsão')
                            return
                        }
                    }
                
                // Verifica se o status é concluído
                } else if (modalDadosChamado.value.data.status == 'CONCLUIDO') {

                    // Verifica se data de conclusão foi preenchida
                    if (!modalDadosChamado.value.data.dataConclusao || modalDadosChamado.value.data.dataConclusao == ''){                     
                        erroStore.exibirErro('Selecione Data de Conclusão')
                        return                    
                    }

                    if (!modalDadosChamado.value.data.executado || modalDadosChamado.value.data.executado == '') {                    
                        erroStore.exibirErro('Descreva o Que Foi Executado')
                        return
                    }

                    if (!modalDadosChamado.value.data.tempoExecucao || modalDadosChamado.value.data.tempoExecucao == '') {
                        erroStore.exibirErro('Entre com o Tempo de Execução do Chamado')
                        return
                    }

                    // Calcula o custo do chamado em função do tempo dispendido e dos recursos usados
                    atualizarCustoTotal();

                } else if (modalDadosChamado.value.data.status == 'ORCAMENTO' ||
                    modalDadosChamado.value.data.status == 'ORCAMENTO APROVADO') {

                    if (!modalDadosChamado.value.data.solicitado || modalDadosChamado.value.data.solicitado == '') {                    
                        erroStore.exibirErro('Descreva o Que Foi Solicitado')
                        return
                    }

                    if (!modalDadosChamado.value.data.descricaoOrcamento || modalDadosChamado.value.data.descricaoOrcamento == '') {                    
                        erroStore.exibirErro('Descreva o Que Será Orçado')
                        return
                    }

                    if (!modalDadosChamado.value.data.custoOrcamento || modalDadosChamado.value.data.custoOrcamento == '0,00') {                    
                        erroStore.exibirErro('Entre Com Custo Do Orçamento')
                        return
                    }
                }
            }

            // Verifica se foi digitado o que foi solicitado            
            if (!modalDadosChamado.value.data.solicitado || modalDadosChamado.value.data.solicitado == '') {                
                erroStore.exibirErro('Entre Com Solicitação do Chamado')
                return
            }

            // Define ordemExibicao com base no status
            const ordemChamados = {
                ABERTO: 0,
                'ORÇAMENTO APROVADO': 1,
                EXECUÇÃO: 2,
                PENDENTE: 3,
                'PENDENTE CLIENTE': 4,
                CONCLUIDO: 5,
                ORCAMENTO: 6,
                'ORÇAMENTO REJEITADO': 7,
                'ATRASADO': 8
            };

            // Salva a ordem de exibição conforme o status do achamado
            modalDadosChamado.value.data.ordemExibicao = ordemChamados[modalDadosChamado.value.data.status] || 0;
            
            // Executa upload dos arquivos anexados e obtém os dados dos arquivos salvos no servidor
            const resultadoUpload = await uploadArquivos(arquivosAnexadosChamado, {
                
                token: loginStore.token,
                onProgress: (progresso) => {
                    
                    // Atualiza o progresso para mostrar no v-progress-linear
                    uploadProgressChamado.value = progresso.percentual;
                }
            });

            // Se upload não retornou erro, salva os dados dos arquivos anexados
            if (resultadoUpload.status != 'erro') {

                // Extrai apenas os dados necessários
                const dadosAnexos = arquivosAnexadosChamado.value.map(arquivo => ({
                    filePath: arquivo.filePath,
                    filename: arquivo.filename,
                    originalName: arquivo.originalName,
                    size: arquivo.size,
                    serverName: arquivo.serverName,
                    uniqueId: arquivo.uniqueId     
                }));

                // Salva os dados dos arquivos anexados
                modalDadosChamado.value.data.arquivosAnexosChamado = dadosAnexos;
                
            } else {
                modalDadosChamado.value.data.arquivosAnexosChamado = [];    
            }

            // Busca id do chamado, caso seja 0 significa que é um novo chamado
            const idChamadoSalvar = modalDadosChamado.value.data.idChamado;

            // Chama API para salvar os dados do chamado
            const resposta = await axios.post(`${API_BASE_URL}/operacao/salvaChamado/${idChamadoSalvar}`, modalDadosChamado.value.data, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Salva id do chamado retornado pela API
            modalDadosChamado.value.data.idChamado = resposta.data.idChamado;

            // Salva o id do chamado na variável reativa para mostrar o acordeon de comentários
            mostraAcordeonComantarios.value = resposta.data.idChamado;

            // Busca imagens que foram inseridas no editor
            const imagensEditor = resposta.data.imagensEditor

            // Verifica se a resposta é um array indicando que existem imagens no editor
            if (Array.isArray(imagensEditor) && imagensEditor.length > 0) {
                
                // Mapeia as novas imagens do editor
                const novasImagens = imagensEditor.map(imagem => ({
                    filePath: imagem.filePath,
                    filename: imagem.filename,
                    originalName: imagem.originalName,
                    size: imagem.size,
                    serverName: imagem.serverName,
                    uniqueId: imagem.uniqueId,
                    isExisting: true,
                    displayName: imagem.displayName || `${imagem.originalName} (${(imagem.size / 1024).toFixed(2)} KB)`,
                    raw: null
                }));
                
                // Filtra apenas as imagens que ainda não existem (verificando por uniqueId)
                const imagensNaoExistentes = novasImagens.filter(novaImagem => 
                    !arquivosAnexadosChamado.value.some(existente => 
                        existente.uniqueId === novaImagem.uniqueId
                    )
                );
                
                // Adiciona apenas as imagens novas ao array existente
                if (imagensNaoExistentes.length > 0) {
                    arquivosAnexadosChamado.value = [
                        ...arquivosAnexadosChamado.value,
                        ...imagensNaoExistentes
                    ];
                }
            }

            // Atualiza o v-file-input (mostraAnexosChamado) com todos os arquivos
            if (arquivosAnexadosChamado.value && arquivosAnexadosChamado.value.length > 0) {

                mostraAnexosChamado.value = arquivosAnexadosChamado.value.map(arquivo => ({
                    name: arquivo.originalName,
                    size: arquivo.size,
                    type: 'application/octet-stream',
                    lastModified: Date.now()
                }));
            }

            // Salva dados da imagem nas variáveis do modal
            modalDadosChamado.value.data.arquivosAnexosChamado = mostraAnexosChamado.value;
            
            // Exibe mensagem de sucesso
            snackbar.trigger('Chamado Salvo Com Sucesso.', 'success');

            // Carrega lista de chamados
            await carregaListaChamados()

            // Verifica a função de retorno após clicar sobre botão salvar
            if (funcaoRetorno == 'salvar'){
                
                return

            // Verifica a função de retorno após clicar sobre botão salvar e retornar
            } else if (funcaoRetorno == 'salvar-retornar'){

                // Fechar o modal e recarregar a lista de chamados
                fecharModalChamados();

            } else {
                
                // Limpa os dados do chamado para um novo chamado
                novoChamado()
            }
            
        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    }; 

    // Função para pedir confirmação de exclusão do chamado
    async function pedeConfirmacaoExclusao(item) {

        // Esconde todos os menus de função da lista
        item.escondeMenu = false;

        // Abre o modal de confirmação de exclusão
        modalExclusao.value = {
            visible: true,
            data: item.idChamado
        }        
    }

    // Função para executar a exclusão do chamado
    async function executarExclusao() {

        if (!modalExclusao.value.data) return

        carregandoExclusao.value = true

        try {

            // Busca o idChamado a ser excluído
            const idChamado = modalExclusao.value.data;

            // Fecha modal e limpa dados
            modalExclusao.value.visible = false
            modalExclusao.value.data = null
            
            // Chama API para excluir o chamado
            await axios.delete(`${API_BASE_URL}/operacao/excluirChamado/${idChamado}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            // Atualiza a lista
            await carregaListaChamados()

        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    }

    // Função para limpar os dados da empresa cliente ao clicar no ícone de limpar do campo de cliente
    function limparDadosEmpresaCliente() {
        
        // Limpa dados do formulário de chamados
        limpaDadosChamado()

        // Carrega todos os produtos e tipos de chamados ativos
        carregaTiposChamado()

        // Exibe o modal com os dados do chamado
        modalDadosChamado.value.visible = true
    }

    // Função para tratar a digitação no campo de cliente
    async function autoCompletaNomeCliente() {
        
        const textoDigitado = modalDadosChamado.value.data.Cliente

        if (textoDigitado.length < 2) {
            sugestoes.value = []
            indiceSelecionado.value = -1
            return
        }

        try {

            const resposta = await axios.get(`${API_BASE_URL}/operacao/autoCompletaCliente`, {
                params: { termo: textoDigitado },
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            sugestoes.value = resposta.data
                .filter(cliente =>
                    cliente.nomeFantasia?.toLowerCase().includes(textoDigitado.toLowerCase())
            )
            .map(cliente => ({
                id: cliente.id,
                nome: cliente.nomeFantasia
            }))
            
            // Resetar seleção quando novos resultados aparecem
            indiceSelecionado.value = -1

        } catch (erro) {
            erroStore.exibirErro(erro)
            sugestoes.value = []
            indiceSelecionado.value = -1
        }        
    }

    // Esta função é chamada quando um cliente é selecionado na lista do resultado
    // da função de autocompleta
    async function selecionarCliente(cliente) {

        try{

            // Atualiza o campo visível com o nome
            modalDadosChamado.value.data.Cliente = cliente.nome

            // Armazena o ID do cliente escolhido, se for necessário para outra lógica
            modalDadosChamado.value.data.idEmpresa = cliente.id

            if (loginStore.emissoraTelevisao === 1){
            
                // Fazendo a requisição para buscar os chamados
                var { data: dataProdutos } = await axios.get(`${API_BASE_URL}/operacao/carregaListaEquipamentos/${loginStore.idEmpresa}/setores/${null}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Garante que temos um array válido de produtos
                const produtos = Array.isArray(dataProdutos.data) 
                    ? dataProdutos.data 
                    : dataProdutos.data || []

                // Carrega os produtos ATIVOS no formato que o v-select precisa
                modalDadosChamado.value.data.produtos = produtos.map(produto => ({
                    value: produto.idEquipamento,
                    title: produto.equipamento
                }))

            } else {
            
                // Carrega os produtos da empresa
                var { data: dataProdutos } = await axios.get(`${API_BASE_URL}/operacao/buscaProdutosEmpresa/${cliente.id}/${loginStore.emissoraTelevisao}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                });
            
                // Garante que temos um array válido de produtos
                const produtos = Array.isArray(dataProdutos.data) 
                    ? dataProdutos.data 
                    : dataProdutos.data || []

                // Filtra apenas produtos ativos (ativo = 1)
                const produtosAtivos = produtos.filter(produto => produto.ativo === 1)

                // Carrega os produtos ATIVOS no formato que o v-select precisa
                modalDadosChamado.value.data.produtos = produtosAtivos.map(produto => ({
                    value: produto.idProduto,
                    title: produto.nome
                }))
            }

            // Busca todos contatos do cliente (solicitantes)
            const { data: dataContatos } = await axios.get(`${API_BASE_URL}/operacao/buscaColaboradoresCliente/${cliente.id}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            });

            const contatos = Array.isArray(dataContatos) ? dataContatos : dataApi.retornoApi || []
            
            // Transforma os contatos no formato que o v-select precisa
            modalDadosChamado.value.data.nomeColaboradorCliente = contatos.map(contato => ({
                value: contato.id, 
                title: contato.nome
            }))

            // Limpar sugestões após seleção
            sugestoes.value = []
            indiceSelecionado.value = -1

            // Tenta focar sempre que o componente é atualizado e o status é CONCLUIDO
            setTimeout(() => {                    
                textAreaSolicitante.value?.focus?.();
            }, 100);

        } catch (erro) {
            erroStore.exibirErro(erro)
        }   

        // Limpa e esconde as sugestões
        sugestoes.value = []
    }
    

    /* FUNÇÕES SISTEMA  */

    // Função para verificar antes de apagar o conteúdo do campo de cliente
    function manipuladorKeyUp(event) {
        
        // Verifica se a tecla pressionada foi Backspace ou Delete
        if (event.key === 'Backspace' || event.key === 'Delete') {
            
            // Se o campo de cliente estiver vazio, limpa os dados da empresa cliente
            if (modalDadosChamado.value.data.Cliente === '') {
                limparDadosEmpresaCliente()
            }
        }
    }

    // Função para lidar com teclas
    function handleKeyDown(event) {

        if (event.key === 'Backspace' || event.key === 'Delete') {
            
            if (modalDadosChamado.value.data.Cliente.length <= 1) {
                limparDadosEmpresaCliente()
                return
            }           
        }

        if (!sugestoes.value.length) return
        
        switch(event.key) {
            case 'ArrowDown':
                event.preventDefault()
                indiceSelecionado.value = (indiceSelecionado.value + 1) % sugestoes.value.length
            break
            
            case 'ArrowUp':
                event.preventDefault()
                if (indiceSelecionado.value <= 0) {
                    indiceSelecionado.value = sugestoes.value.length - 1
                } else {
                    indiceSelecionado.value--
                }
            break
            
            case 'Enter':
                if (indiceSelecionado.value >= 0) {
                    event.preventDefault()
                    selecionarCliente(sugestoes.value[indiceSelecionado.value])
                }
            break
            
            case 'Escape':
                sugestoes.value = []
                indiceSelecionado.value = -1
            break
        }
    }
    
    // Funções com verificação de segurança
    function buscaTitulo(valor) {
        if (!valor) return ''
        const opcao = opcoesStatus.value.find(op => op.value === valor)
        return opcao ? opcao.title : valor
    }
    
    // Função que retorna a cor do chip conforme o status
    function getChipColor(valor) {

        // Se valor for nulo ou indefinido, retorna cinza
        if (!valor) return 'grey'
        
        const cores = {
            'ABERTO': 'orange',
            'EXECUCAO': 'blue',
            'PENDENTE': 'red',
            'PENDENTE CLIENTE': 'deep-orange',
            'ORCAMENTO': 'green',
            'ORCAMENTO APROVADO': 'green',
            'ORCAMENTO REJEITADO': 'grey',
            'CONCLUIDO': 'teal'
        }
        return cores[valor] || 'grey'
    }

    // Busca valor de cada staus
    function buscaContagem(valor) {
        
        if (!valor) {            
            return 0
        }

        return contagemStatus.value[valor] || 0
    }

    // Função chamada quando o botão para remover um status é pressionado
    function removerStatus(status) {
        
        // Se não houver status selecionado retorna
        if (!status) return

        // Remove status selecionado
        statusSelecionados.value = statusSelecionados.value.filter(s => s !== status)

        // Carrega lista de chamados para mostrar a nova seleção
        carregaListaChamados()
    }

    // Esta função faz a contagem de chamados para cada status
    function contarStatusDosChamados(chamados) {

        // Inicializa a nova contagem
        const novaContagem = {}
        
        // Se não há status selecionados OU se "todos" estão selecionados, conta todos os status
        if (!statusSelecionados.value || statusSelecionados.value.length === 0) {
            
            // Opção 1: Contar todos os status
            opcoesStatus.value.forEach(status => {
                novaContagem[status.value] = 0
            })

        } else {
            
            // Conta SOMENTE os status selecionados
            statusSelecionados.value.forEach(status => {
                novaContagem[status] = 0
            })
        }
        
        // Conta cada status do chamado (somente se o status estiver sendo contado)
        chamados.forEach(chamado => {
            if (novaContagem.hasOwnProperty(chamado.Status)) {
                novaContagem[chamado.Status]++
            }
        })
        
        // Atualiza a variável reativa
        contagemStatus.value = novaContagem
        
        // Retorna a nova contagem
        return novaContagem
    }

    // Se o campo foi limpo, recarrega a lista de chamados        
    function atualizaParamentrosBusca(novoValor) {
        if (!novoValor) {
            carregaListaChamados()
        }
    }
    
    // Esta rotina limpa os dados do formulário modal de chamados
    function limpaDadosChamado() {

        const dataHoraAtual = new Date();
        
        modalDadosChamado.value.visible = false
        
        Object.assign(modalDadosChamado.value.data, {
            idChamado: 0,
            Cliente: null,
            idEmpresa: null,
            idAbriuChamado: null,
            nomeColaboradorCliente: [],
            idProduto: [],
            produtos: [],
            idTipoChamado: [],
            tipoChamados: [],
            status: 'ABERTO',
            prioridade: 'BAIXA',
            idColaboradorSuporte: [],            
            nomeColaboradorSuporte: [],
            custoChamado: 'R$ 0,00',
            solicitado: null,
            executado: null,
            pendencia: null,
            dataAbertura: proxy.$formataDataBrasil(dataHoraAtual),
            dataExecucao: null,
            dataConclusao: null,
            dataPendencia: null,
            dataPrevisaoPendencia: null,
            dataPrevisaoConclusao: null,
            dataOrcamento: null,
            tempoExecucao: null,
            tagChamado: null,
            ordemExibicao: 0,
            descricaoOrcamento: null,
            horasDesenvolvimento: null,
            custoOrcamento: 'R$ 0,00',
            orcamentoLiberado: 0,
            chamadoNotificado: true,
            arquivosAnexosChamado: [],
            envioEmailCliente: true
        })

        desabilitarCampoCliente.value = false;
        desabilitarCampoSolicitado.value = false;
        
        // Limpa elemento de upload de arquivos
        arquivosAnexadosChamado.value = [];

        // Zera valor da variável reativo contendo a lista de comentários
        mostraAcordeonComantarios.value = 0   
        
        sugestoes.value = []
        indiceSelecionado.value = -1
    };
    
    // Esta rotina é chamada quando o X do texto da pesquisa é pressionado
    function limpaDadosPesquisa(){
        textoBusca.value = ''
        carregaListaChamados()
    }

    //Esta rotina limpa os dados do formulário modal de comentários
    function limpaDadosComentario() {

        // Pega data atual em formato ISO 8601
        const dataAtual = proxy.$formataDataBrasil(new Date().toISOString());
        
        // Fecha o modal
        modalDadosComentario.value.visible = false
        
        // Limpa os dados do formulário
        Object.assign(modalDadosComentario.value.data, {
            id: 0,
            idChamado: 0,
            idComentou: 0,
            idQuemLeu: 0,
            textoComentario: '',
            dataComentario: dataAtual,
            nomeQuemComentou: '',
            nomeQuemLeu: '',
            comentarioLido: false,
            arquivosAnexosComentario: []
        })

        // Limpa elemento de upload de arquivos
        arquivosAnexadosComentario.value = [];
        mostraAnexosComentario.value = [];
        
        // Habilita o botão porque não existe comentário
        desabilitarSalvarModalComentarios.value = false;
    };

    // Função para fechar modal do chamado
    function fecharModalChamados() {
        modalDadosChamado.value.visible = false
    };

    // Função para fechar modal do registro de chamado
    function fecharModalRegistroChamado(){
        modalRegistroChamado.value.visible = false
    }

    function fecharModalComentario() {
        modalDadosComentario.value.visible = false
    };

    // Esta fução trata da expansão dos comentários do chamado ao se clicar no ícone de comentários
    function linhaComentarios(codigo) {
        return comentariosExpandidos.value.includes(codigo)
    };

    // Esta fução trata da expansão do registro de chamado ao se clicar no ícone de comentários
    function linhaRegistrosChamados(codigo) {
        return registrosExpandidos.value.includes(codigo)
    };

    // Esta função converte tempo hhh:mm em horas
    function converterTempoParaHoras(tempoStr) {

        const [hStr, mStr] = tempoStr.split(':');
        const horas = parseInt(hStr) || 0;
        const minutos = parseInt(mStr) || 0;
        return horas + minutos / 60;
    }

    // Atualiza custo do chamado usando o valor do tempo do chamado
    function atualizarCustoTotal() {

        // Busca tempo do chamado
        const tempoStr = modalDadosChamado.value.data.tempoExecucao;
        
        // Entra na rotina se o tempo do chamado foi expecificado
        if (tempoStr){

            // Converte o tempo em horas
            const horasTotais = converterTempoParaHoras(tempoStr);

            // Filtra somente  usuários selecionados
            const colaboradoresSelecionados = modalDadosChamado.value.data.nomeColaboradorSuporte.filter(colaboradorSuporte =>
                modalDadosChamado.value.data.idColaboradorSuporte.includes(colaboradorSuporte.value)
            );

            // Soma os valores da hora de cada usuário
            const somaValorHora = colaboradoresSelecionados.reduce(
                (total, colaboradoresSelecionados) => total + (colaboradoresSelecionados.valorHora || 0), 0
            );

            // Multiplica pelo número de horas
            custoCalculoChamado = somaValorHora * horasTotais;

            // Monta mascara do valor retornado do calculo
            modalDadosChamado.value.data.custoChamado = custoCalculoChamado.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        }
    }

    // Função para selecionar linha
    function selecionarLinha(codigo) {
        linhaSelecionada.value = linhaSelecionada.value.includes(codigo) ? [] : [codigo]
    }

    // Função para calcular a diferença entre duas datas com horas e minutos
    function diferencaComHora(data1Str, data2Str) {

        const [data1, hora1] = data1Str.split(' ');
        const [dia1, mes1, ano1] = data1.split('/');
        const [h1, min1] = hora1.split(':');

        const [data2, hora2] = data2Str.split(' ');
        const [dia2, mes2, ano2] = data2.split('/');
        const [h2, min2] = hora2.split(':');

        const dt1 = new Date(ano1, mes1 - 1, dia1, h1, min1);
        const dt2 = new Date(ano2, mes2 - 1, dia2, h2, min2);

        const diffMs = dt2 - dt1;
        const totalMin = Math.floor(diffMs / (1000 * 60));
        let horas = Math.floor(totalMin / 60);
        let minutos = totalMin % 60;

        // Formatando com 2 dígitos
        horas = String(horas).padStart(2, '0');
        minutos = String(minutos).padStart(2, '0');

        return { horas, minutos };
    }
    
    // Limpa texto de comando html
    function limpaTextoHtml(textoEntrada){
        
        const html = textoEntrada || ''
        
        const div = document.createElement('div')
        div.innerHTML = html
        return div.textContent || ''    
    }

    // Retorna a cor associada ao status do chamado para o botões da lista
    function statusColor(status) {

        switch (status) {
            case 'ABERTO': return 'orange'
            case 'PENDENTE': return 'red'
            case 'PENDENTE CLIENTE': return 'red'
            case 'EXECUCAO': return 'blue'
            case 'CONCLUIDO': return 'green'
            case 'ORCAMENTO': return 'yelLow'
            case 'ORCAMENTO APROVADO': return 'green'
        default:
            return 'black'
        }
    }

    /* FUNÇÕES ASSINCRONAS  */

    // Esta função é responsável por processar a edição do chamado quando o ID é recebido pela query da rota
    const processarEdicao = (id) => {

        if (id && id !== '0') {
            
            // Atualiza a rota sem recarregar a página
            const novoQuery = { ...route.query }
            
            // Remove o parâmetro 'id' da query
            delete novoQuery.id

            // Adiciona o parâmetro 'id' com o valor do chamado a ser editado
            router.replace({ query: novoQuery })
            
            // Chama a função de edição do chamado com o id recebido
            editaChamado({ idChamado: id, acao: 0 })
        }
    }

    // Esta função é chamada quando o formulário é carregado
    onMounted(() => {

        // Listener para mudanças do drawer
        const manipuladorMudancaTamanho = (data) => {
            modoBarraLateral.value = data
        }

        // Adiciona listener para mudanças do drawer
        emitter.on('mudancaBarraLateral', manipuladorMudancaTamanho)

        // Processa ID inicial se existir
        processarEdicao(route.query.id)

    })

    // Limpar o timer quando o componente for destruído
    onBeforeUnmount(() => {

        if (timeoutId) clearTimeout(timeoutId)

        // Limpar listener
        emitter.off('mudancaBarraLateral')

        // Limpar timer
        if (timerId) clearInterval(timerId)
    })

    // Monitora mudanças no ID
    watch(() => route.query.id, (novoId) => {
        processarEdicao(novoId)
    })

    // Esta rotina é disparada quando o modal é aberto ou fechado
    watch(() => modalDadosChamado.value.visible, async (valor) => {
        modalChamadoAberto = valor
    })

    // Monitora o campo status e se a condição mudar para aberto limpa os calendários, tempo do chamado e custo do orçamento
    watch(() => modalDadosChamado.value.data.status, async (novoStatus, statusAntigo) => {

            // Se o modal ainda não estiver carregado sai da rotina
            if (!modalChamadoAberto) return;

            // Busca a data e hora atuais no formato brasileiro
            const dataHoraAtual = new Date();
                
            // Se o status for aberto coloca a data atual no campo data abertura 
            // limpa o restante dos campos de horarios, tempo de chamado e custo 
            if (modalDadosChamado.value.data.status === 'ABERTO') {

                // Habilida campo da solicitação
                desabilitarCampoSolicitado.value = false

                // Limpa os recursos selecionados
                modalDadosChamado.value.data.idColaboradorSuporte = []
                
                // Limpa campo pendencia
                modalDadosChamado.value.data.pendencia = null

                // Limpa data de previsão da pendencia
                modalDadosChamado.value.data.dataPrevisaoPendencia = null

                // Limpa data de previsão da pendencia
                modalDadosChamado.value.data.dataPrevisaoConclusao = null

                // Limpa campo executado
                modalDadosChamado.value.data.executado = null

                // Limpa campo de tempo de execução
                modalDadosChamado.value.data.tempoExecucao = null
                
                // Limpa campo do custo do chamado
                modalDadosChamado.value.data.custoChamado = 'R$ 0,00'
                
                // Limpa campo da descrição do orçamento
                modalDadosChamado.value.data.descricaoOrcamento = null
                
                // Limpa campo do custo do orçamento
                modalDadosChamado.value.data.custoOrcamento = 'R$ 0,00'
                
                // Mostra a data atual como data de abertura
                modalDadosChamado.value.data.dataAbertura = proxy.$formataDataBrasil(dataHoraAtual)

                // Limpa campo da data de execução
                modalDadosChamado.value.data.dataExecucao = null

                // Limpa campo da data de pendência
                modalDadosChamado.value.data.dataPendencia = null

                // Limpa data de conclusão
                modalDadosChamado.value.data.dataConclusao = null                

            // Se o status for execução coloca a data atual no campo de data execução
            } else if (modalDadosChamado.value.data.status === 'EXECUCAO') {
            
                // Limpa data de conclusão
                modalDadosChamado.value.data.dataConclusao = null                

                // Mostra a data atual no campo data execução
                modalDadosChamado.value.data.dataExecucao = proxy.$formataDataBrasil(dataHoraAtual)

            // Se o status for pendente ou pendente cliente limpa tempo de execução, conclusão, custo do chamado
            // coloca a data atual no campo de data pendência
            } else if (modalDadosChamado.value.data.status === 'PENDENTE' ||
                       modalDadosChamado.value.data.status === 'PENDENTE CLIENTE') {
            
                // Limpa campo de tempo de execução
                modalDadosChamado.value.data.tempoExecucao = null
                
                // Limpa data de conclusão
                modalDadosChamado.value.data.dataConclusao = null                

                // Limpa campo do custo do chamado
                modalDadosChamado.value.data.custoChamado = 'R$ 0,00'
                
                // Atualiza com a data e hora local o campo de data pendência
                modalDadosChamado.value.data.dataPendencia = proxy.$formataDataBrasil(dataHoraAtual)

                // Tenta focar sempre que o componente é atualizado e o status é CONCLUIDO
                setTimeout(() => {                    
                    textAreaPendente.value?.focus?.();
                }, 100);
                
            // Se o status do chamado for concluído e houver uma data de execução, calcula o tempo do chamado
            } else if (modalDadosChamado.value.data.status === 'CONCLUIDO') {
            
                // Verifica se foi selecionado ao menos um recurso para executar o chamado
                if (modalDadosChamado.value.data.idColaboradorSuporte.length == 0){

                    modalDadosChamado.value.data.status = statusAntigo
                    erroStore.exibirErro('Selecione Um Ou Mais Recursos para Concluir Chamado')
                    return
                }                

                // Se ainda não tiver uma data de execução assume menos uma hora da data e hora atual
                if (!modalDadosChamado.value.data.dataExecucao || modalDadosChamado.value.data.dataExecucao == ''){

                    const dataHoraMenosUmaHora = new Date(dataHoraAtual.getTime() - 3600000);
                    modalDadosChamado.value.data.dataExecucao = proxy.$formataDataBrasil(dataHoraMenosUmaHora);
                }

                // Se ainda não tiver uma data de conclusão assume a data e hora atual
                if (!modalDadosChamado.value.data.dataConclusao || modalDadosChamado.value.data.dataConclusao == ''){
                    modalDadosChamado.value.data.dataConclusao = proxy.$formataDataBrasil(dataHoraAtual);
                }

                // Calcula a diferença entre a data de execução e conclusão
                const resultadoDiferenca = diferencaComHora(
                        modalDadosChamado.value.data.dataExecucao, 
                        modalDadosChamado.value.data.dataConclusao
                )
                
                // Insere diferença entre a hora de execução e conclusão no campo de tempo de chamado
                modalDadosChamado.value.data.tempoExecucao = `${resultadoDiferenca.horas}:${resultadoDiferenca.minutos}`
                
                // Tenta focar sempre que o componente é atualizado e o status é CONCLUIDO
                setTimeout(() => {                    
                    textAreaExecutado.value?.focus?.();
                }, 100);

            } else if (modalDadosChamado.value.data.status === 'ORCAMENTO' ||
                       modalDadosChamado.value.data.status === 'ORCAMENTO APROVADO' ||
                       modalDadosChamado.value.data.status === 'ORCAMENTO REJEITADO') {
                        
                // Tenta focar sempre que o componente é atualizado e o status é CONCLUIDO
                setTimeout(() => {                    
                    textAreaOrcamento.value?.focus?.();
                }, 100);
            }
        },
        { deep: true }
    );
    
    // Monitora a mudança de recursos e recalcula o custo do chamado se estiver com status de concluído
    watch(() => modalDadosChamado.value?.data?.idColaborador, () => {
            
            // Se o modal ainda não estiver carregado sai da rotina
            if (!modalChamadoAberto) return;

            // Verifica se o chamado já está concluido 
            if (modalDadosChamado.value.data.status == 'CONCLUIDO' ){

                // Calcula o custo do chamado se o campo tempoExecucao estiver com algum valor
                atualizarCustoTotal();                
            }
        },
        { deep: true } // observa arrays reativos
    );

    // Monitora a mudança no tempo do chamado
    watch(() => modalDadosChamado.value.data.tempoExecucao,(novoValor, valorAntigo) => {
        
            // Se o modal ainda não estiver carregado sai da rotina
            if (!modalChamadoAberto) return;

            // Verifica se a variável tem um valor válido
            if (novoValor === '' || novoValor === 'NaN:NaN' || novoValor === null){
                modalDadosChamado.value.data.custoChamado = '0,00'
                return
            }
            
            // Atualiza custo do chamado
            atualizarCustoTotal();
        }
    )

    // Monitora a data de conclusão do chamado para calcular o tempo do mesmo
    watch(() => modalDadosChamado.value.data.dataConclusao, () => {

            if (!modalChamadoAberto) return;

            if (modalDadosChamado.value.data.status === 'CONCLUIDO' && modalDadosChamado.value.data.dataExecucao) {
            
                const resultadoDiferenca = diferencaComHora(modalDadosChamado.value.data.dataExecucao, modalDadosChamado.value.data.dataConclusao)
                
                // Insere diferença entre a hora de execução e conclusão no campo de tempo de chamado
                modalDadosChamado.value.data.tempoExecucao = `${resultadoDiferenca.horas}:${resultadoDiferenca.minutos}`                
            }
        },
        { deep: true }
    );
        
    // Observa mudanças no acordeão para carregar colaboradores quando aberto
    watch(acordeonComentarios, (val) => {
        
        if (Array.isArray(val)) {
            
            if (val.includes(0)) {
                carregarListaComentariosAcordeon()
            }
            
        } else if (val === 0) {
            carregarListaComentariosAcordeon()
        }
    })    

    // Watcher para detectar pedido de recarregamento
    watch(() => chamadoStore.precisaRecarregar, (precisaRecarregar) => {
            if (precisaRecarregar) {
                carregaListaChamados()
            }
        }
    )
    
</script>


<style>

    .blink-color-status {
        animation: blink-color-status 1s infinite;
    }

    @keyframes blink-color-status {
        0%   { background-color: #f32121; color: white; }
        50%  { background-color: rgb(2, 69, 253); color: #ffffff; }
        100% { background-color: #f3de21; color: white; }
    }

    .tabela-fixa {
       table-layout: fixed;
    }

    .linha-chamado-selecionada {
        background-color: #e6e6e6;
        color: rgb(15, 15, 15);
    }

    tr {
        cursor: pointer;
    }

    .col-codigo a {
        color: inherit;
        text-decoration: none;
        font-weight: bold;
    }

    .col-codigo a:hover {
        text-decoration: underline;
        color: #1976d2;
    }
    
    .menu-hover {
        transition: background-color 0.3s ease;
        border-radius: 4px;
    }

    .menu-hover:hover {
        background-color: #94cdf7; /* azul claro */
        color: white !important;        
        color: black !important;
    }

    .tabela-com-divisores {
        table-layout: fixed;
    }

    .tabela-com-divisores td,
    .tabela-com-divisores th {
        border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .tabela-com-divisores td:last-child,
    .tabela-com-divisores th:last-child {
        border-right: none;
    }

    .rounded-button {
        border-radius: 50%;
    }

    .botao-circulo {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #007bff;
        color: white;
        border: none;
        font-size: 18px;
        cursor: pointer;
    }
    .botao-circulo:hover {
        background-color: #0056b3;
    }

    .blinkIcone {
        animation: blink-color-status 1s infinite;
    }

    @keyframes blinkIcone {
        0%   { background-color: #f32121; color: white; }
        50%  { background-color: rgb(2, 69, 253); color: #ffffff; }
        100% { background-color: #f3de21; color: white; }
    }
    
    /* Estilos para campos desabilitados no Quill Editor */
    .campos-desabilitados .quill-editor-wrapper :deep(.ql-toolbar),
    .campos-desabilitados .quill-editor-wrapper :deep(.ql-container) {
        background-color: #f5f5f5;
        opacity: 0.8;
    }

    .campos-desabilitados .quill-editor-wrapper :deep(.ql-editor) {
        color: #000000 !important;
    }
    
    /* Aplica o tamanho da fonte ao container principal do editor */
    .ql-container {
        font-size: 18px; /* Altere para o tamanho desejado */
    }

    /* Garante que a área de edição herde o tamanho da fonte */
    .quill-editor-wrapper :deep(.ql-editor) {
        font-size: 18px; /* Altere para o tamanho desejado */
    }

</style>

<style scoped>

    /* CSS que permite redimensionamento */
    .quill-editor-redimensionavel {
        resize: vertical;
        overflow: hidden;
        min-height: 150px;
        max-height: 500px;
        display: flex;
        flex-direction: column;
    }

    .quill-editor-redimensionavel :deep(.ql-container) {
        height: auto !important;
        flex: 1;
        overflow-y: auto;
    }

    .quill-editor-redimensionavel :deep(.ql-toolbar) {
        flex-shrink: 0;
    }

    .quill-editor-redimensionavel :deep(.ql-editor) {
        min-height: 100px;
    }

    /* Seus outros estilos existentes */
    .quill-editor-wrapper {
        position: relative;
    }

    .quill-label {
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.6);
    }

    .count-badge {
        background-color: white;
        color: #1976d2;
        border-radius: 10px;
        padding: 2px 8px;
        font-size: 0.75rem;
        font-weight: bold;
        min-width: 24px;
        text-align: center;
        display: inline-block;
        margin-left: 6px;
        border: 1px solid #1976d2;
    }

    .linha-comentario-selecionada {
        background-color: white !important;
    }

    .linha-registro-chamado-selecionada {
        background-color: white !important;
    }

    .botao-circulo {
        background-color: transparent;
        border: none;
        cursor: pointer;
    }

    .v-icon {
        font-size: 20px;
    }

    .btn-icon {
        width: 42px;
        height: 42px;
    }

    .btn-icon:hover {
        background-color: #f0f0f0;
        border-radius: 4px;
    }

    .accordion-container {
        width: 100%;
        margin-top: 16px;
    }

    .accordion-toggle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #eee;
        border: none;
        padding: 12px 16px;
        font-weight: bold;
        cursor: pointer;
    }

    .accordion-content {
        padding: 12px 16px;
        background-color: #f9f9f9;
        border-top: 1px solid #ccc;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }

    .btn-verde {
        margin-top: 12px;
        background-color: #4CAF50;
        color: white;
        padding: 8px 12px;
        border: none;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: bold;
        cursor: pointer;
    }

    .editor {
        margin-top: 16px;
    }

    :deep(.ql-editor) {
    padding: 0;
    }

    :deep(.comentario) {
        margin-bottom: 1.5rem;
        padding-bottom: 1rem;
    }

    :deep(.cabecalho-comentario) {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.5rem;
        font-size: 0.9rem;
    }

    :deep(.autor) {
        font-weight: bold;
        color: #1976d2; /* Cor primária do Vuetify */
    }

    :deep(.data) {
        color: #616161; /* Cinza médio */
    }

    :deep(.conteudo) {
    line-height: 1.6;
    margin-left: 0.5rem;
    }

    :deep(.separador) {
        border: none;
        border-top: 1px dashed #e0e0e0;
        margin: 1rem 0;
    }

    :deep(.erro) {
        color: #d32f2f;
        padding: 0.5rem;
        background-color: #ffebee;
        border-radius: 4px;
    }

    /* Estilos upload */
    .file-upload {
        max-width: 500px;
        margin: 0 auto;
        padding: 20px;
        border: 1px solid #ddd;
        border-radius: 8px;
        background-color: #f9f9f9;
    }

    .file-input {
        display: none;
    }

    .upload-button {
        margin: 10px 5px;
        padding: 8px 16px;
        background-color: #42b983;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .upload-button:hover {
        background-color: #3aa876;
    }

    .upload-button:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }

    .file-list {
        margin-top: 20px;
    }

    .file-list ul {
        list-style: none;
        padding: 0;
    }

    .file-list li {
        padding: 8px;
        margin: 5px 0;
        background-color: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .remove-button {
        background: none;
        border: none;
        color: #ff4444;
        font-size: 1.2em;
        cursor: pointer;
        padding: 0 5px;
    }

    .progress-container {
        margin-top: 15px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .progress-container progress {
        flex-grow: 1;
    }

    .message {
        margin-top: 15px;
        padding: 10px;
        border-radius: 4px;
        background-color: #dff0d8;
        color: #3c763d;
    }

    .message.error {
        background-color: #f2dede;
        color: #a94442;
    }

    .v-chip--primary {
        cursor: pointer;
    }

    .custom-switch ::v-deep(.v-label) {
        font-size: 14px;
        transform: scale(0.8);
        transform-origin: left center;
        margin-right: -50px;
        height: 32px !important;
    }

    /* Estilos para a tabela de comentários */
    .comentarios-table {
        width: 100%;
        table-layout: fixed;    /* respeita larguras fixas se houver */
        border-collapse: collapse;  /* faz as bordas “se tocarem” sem espaços */
    }

    /* Bordas horizontais: uma linha preta embaixo de cada célula do corpo */
    .comentarios-table tbody td {
        border-bottom: 1px solid #b4a4a4;
        padding: 8px 12px;      /* ajuste seu padding conforme o design */
    }

    /* Opcional: linha separadora abaixo do cabeçalho */
    .comentarios-table thead th {
        border-bottom: 2px solid #b4a4a4;
        padding: 8px 12px;
    }

    /* Remove a última linha horizontal (evita borda extra no final) */
    .comentarios-table tbody tr:last-child td {
        border-bottom: none;
    }

    .campos-desabilitados {
        /* Remove a opacidade padrão */
        --v-disabled-opacity: 1;
    }

    /* Estiliza o select quando desabilitado */
    .campos-desabilitados :deep(.v-field--disabled) {
        opacity: 1 !important;
    }

    /* Estiliza o texto do input quando desabilitado */
    .campos-desabilitados :deep(.v-field--disabled .v-field__input) {
        color: #000000 !important;
    }

    /* Estiliza o texto selecionado quando desabilitado */
    .campos-desabilitados :deep(.v-field--disabled input) {
        color: #000000 !important;
        -webkit-text-fill-color: #000000 !important;
    }

    /* Estiliza o label quando desabilitado e flutuante */
    .campos-desabilitados :deep(.v-field--disabled .v-label.v-field-label--floating) {
        color: #000000 !important;
    }

    /* Estiliza o ícone de dropdown quando desabilitado */
    .campos-desabilitados :deep(.v-field--disabled .v-field__append-inner i) {
        color: #000000 !important;
        opacity: 0.6 !important;
    }

    /* Para garantir que o placeholder também fique preto se existir */
    .campos-desabilitados :deep(.v-field--disabled .v-field__input::placeholder) {
        color: #0cd305 !important;
        font-weight: normal !important;
    }    
    
</style>
